import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import { Button, ButtonGroup, Row, Col, Container, Table } from 'react-bootstrap';
import { C4FStatusContext, ReferenceDataContext, UserInformationContext } from "./App";
import '../css/general.css';
import C4FPrizeMoney from "../race/C4FPrizeMoney";
import SkillClimbing from "../img/icons/skill-climbing.png";
import SkillFlat from "../img/icons/skill-flat.png";
import SkillDownhill from "../img/icons/skill-downhill.png";
import SkillTimeTrial from "../img/icons/skill-timetrial.png";
import SkillSprint from "../img/icons/skill-sprint.png";
import SkillCobbles from "../img/icons/skill-cobbles.png";
import SkillRegeneration from "../img/icons/skill-regeneration.png";
import { tourJerseyMapping, getJersey } from "../race/C4FLeaderJerseys";
import config from "../etc/config.json";
import C4FSimpleTable from "../common/C4FSimpleTable";
import releaseNotes from "./ReleaseNotes.json";
import { formatCurrency, sum, getUnicodeFlag, isNumber, roundDigits, printJSONObject, randomNumber, getRandomArrayElement as randomArrayElement, isAdmin, isDeveloper, isDevelopmentSupport } from "../common/Helpers";
import C4FSimpleTextField from "../common/C4FSimpleTextField";
import C4FReferenceDataSelection from "../common/C4FReferenceDataSelection";
import { formBonus, calculateSkill, calculateEffectiveSkill, calculatePrecipitationFactor, calculateRoadFactor, calculateSectorSpeed, calculateSpeed, calculateWindFactor, randomFactor, calculateEnergyFactor, calculateRelativeWindforce, calculateRiderSalary, calculateRiderValue } from "../race/RaceEngine";

function Manual(props) {
  const { userInformation } = useContext(UserInformationContext);
  const { countries, raceEngine } = useContext(ReferenceDataContext);
  const [riderOne, setRiderOne] = useState({ 
    "age": 25,
    "climbing": 50, 
    "flat": 75, 
    "downhill": 60, 
    "timeTrial": 50, 
    "sprint": 50, 
    "cobbles": 75,
    "regeneration": 50,
    "energy": 1000,
    "form": 92,
    "intensity": "Red",
    "randomFactor": randomFactor()
  });
  const [riderTwo, setRiderTwo] = useState({ 
    "age": 25,
    "climbing": 70, 
    "flat": 80, 
    "downhill": 75, 
    "timeTrial": 50, 
    "sprint": 50, 
    "cobbles": 75,
    "regeneration": 35,
    "energy": 1000,
    "form": 92,
    "intensity": "Red",
    "randomFactor": randomFactor()
  });
  const [weather, setWeather] = useState({ 
    "temperature": 20, 
    "clouds": "Sunny", 
    "precipitation": "None", 
    "windforce": 5,
    "windDirection": 135,
  });
  const [sector, setSector] = useState({ 
    "direction": "Winding", 
    "width": "Wide", 
    "coverage": "None",
    "bearing": 0
  });

  const sectorDirectionTypes = ['Straight', 'Winding', 'Hairpins'];
  const sectorWidthTypes = ['Narrow', 'Average', 'Wide', 'VeryWide'];
  const sectorCoverageTypes = ['None', 'Medium', 'Covered']
  const weatherCloudTypes = ['Clear', 'Sunny', 'Fair', 'SlightlyCloudy', 'PartlyCloudy', 'Cloudy', 'VeryCloudy', 'MostlyCloudy', 'Overcast'];
  const weatherPrecipitationTypes = ['None', 'Light', 'Medium', 'Heavy'];

  const [selectedSectorType, setSelectedSectorType] = useState(null);
  
  const [tab, setTab] = useState('manual');
  const [subTab, setSubTab] = useState('market');
  const [userRoles, setUserRoles] = useState(null);  
  const [cashJournal, setCashJournal] = useState(null);
  const { handleBackendRequest, browserInfo } = useContext(C4FStatusContext);
  const specialJerseys = [
    {"name": "C4FLeader","enum": 7, "file": "wr1"},
    {"name": "WCRoad","enum": 9, "file": "wc"},
    {"name": "WCRoadU23","enum": 10, "file": "wcu23"},
    {"name": "WCITT","enum": 11, "file": "wcitt"},
    {"name": "WCITTU23","enum": 12, "file": "wcittu23"},
    {"name": "OCRoad","enum": 14, "file": "ocroad"},
    {"name": "OCITT","enum": 15, "file": "ocitt"},
    {"name": "RedLantern","enum": 16, "file": "redlantern"},
    {"name": "ECRoad","enum": 17, "file": "ecroad"},
    {"name": "ECITT","enum": 18, "file": "ecitt"}
  ];

  useEffect(() => {
    handleBackendRequest('GET', '/user', null, { context: 'specialRoles' }, setUserRoles);
    handleBackendRequest('GET', '/generalInformation/cashJournal', null, null, setCashJournal);
  }, []);

  useEffect(() => {
    if (raceEngine && !selectedSectorType) {
      handleSetSelectedSectorType(raceEngine.sectorTypes[0]);
    }    
  }, [raceEngine, selectedSectorType]);

  function handleSetRandomSkillFactor() {
    updateRider('randomFactorRiderOne', randomFactor());    
  }

  function handleSetSelectedSectorType(sectorType, sectorDetails = null) {
    sectorDetails = sectorDetails ? sectorDetails : sector;
    let sectorTypeConfiguration = raceEngine.sectorTypes.find(s => s.name === sectorType.name);
    setSelectedSectorType({ ...sectorTypeConfiguration, ...sectorDetails });
  }

  function updateWeather(key, value) {
    let updatedWeather = structuredClone(weather);
    updatedWeather[key] = isNumber(updatedWeather[key]) ? Number(value) : value;
    setWeather(updatedWeather);
  }

  function updateSector(key, value) {
    let updatedSector = structuredClone(sector);
    updatedSector[key] = isNumber(updatedSector[key]) ? Number(value) : value;
    setSector(updatedSector);
    handleSetSelectedSectorType(selectedSectorType, updatedSector);
  }

  function updateRider(key, value) {
    let isRiderOne = key.includes('RiderOne');
    key = key.substring(0, key.indexOf('Rider'));

    let updatedRider = structuredClone(isRiderOne ? riderOne : riderTwo);
    updatedRider[key] = isNumber(updatedRider[key]) ? Number(value) : value;    
    if (isRiderOne)
      setRiderOne(updatedRider);
    else
      setRiderTwo(updatedRider);
  }

  function getCalculatedSkillFormula(sector = null) {
    if (!sector)
      sector = selectedSectorType;

    if (sector) {
      let skillsFactors = [];
      let totalWeights = 0;
      if (sector.skillCalculation.climbing) {
        skillsFactors.push(sector.skillCalculation.climbing + ' * climbing');
        totalWeights += sector.skillCalculation.climbing;
      }
      if (sector.skillCalculation.flat) {
        skillsFactors.push(sector.skillCalculation.flat + ' * flat');
        totalWeights += sector.skillCalculation.flat;
      }
      if (sector.skillCalculation.downhill) {
        skillsFactors.push(sector.skillCalculation.downhill + ' * downhill');
        totalWeights += sector.skillCalculation.downhill;
      }
      if (sector.skillCalculation.timeTrial) {
        skillsFactors.push(sector.skillCalculation.timeTrial + ' * timeTrial');
        totalWeights += sector.skillCalculation.timeTrial;
      }
      if (sector.skillCalculation.cobbles) {
        skillsFactors.push(sector.skillCalculation.cobbles + ' * cobbles');
        totalWeights += sector.skillCalculation.cobbles;
      }
      if (sector.skillCalculation.sprint) {
        skillsFactors.push(sector.skillCalculation.sprint + ' * sprint');
        totalWeights += sector.skillCalculation.sprint;
      }
      
      return '( ' + skillsFactors.join(' + ') + ' ) / ' + totalWeights;
    }
    else return 'no sector selected';
  }

  function randomizeRider(rider) {
    let updatedRider = structuredClone(rider);
    updatedRider.climbing = randomNumber(45, 85);
    updatedRider.flat = randomNumber(45, 85);
    updatedRider.downhill = randomNumber(45, 82);
    updatedRider.timeTrial = randomNumber(45, 75);
    updatedRider.sprint = randomNumber(45, 90);
    updatedRider.energy = randomNumber(500, 1000);
    updatedRider.form = randomNumber(85, 100);
    updatedRider.randomFactor = randomFactor();
    return updatedRider;
  }
  function randomizeSector() {
    let updatedSector = structuredClone(sector);
    updatedSector.direction = randomArrayElement(sectorDirectionTypes);
    updatedSector.coverage = randomArrayElement(sectorCoverageTypes);
    updatedSector.width = randomArrayElement(sectorWidthTypes);
    updatedSector.bearing = randomFactor(0, 359);

    handleSetSelectedSectorType(
      raceEngine.sectorTypes[randomNumber(0, raceEngine.sectorTypes.length - 1)],
      updatedSector);
  }
  function randomizeWeather() {
    let updatedWeather = structuredClone(weather);
    updatedWeather.temperature = randomNumber(-5, 40);
    updatedWeather.clouds = randomArrayElement(weatherCloudTypes);
    updatedWeather.precipitation = randomArrayElement(weatherPrecipitationTypes);
    updatedWeather.windforce = randomNumber(0, 12);
    updatedWeather.windDirection = randomNumber(0, 359);
    setWeather(updatedWeather);
  }

  return <Container fluid className="m-1">
    <Row className="d-flex justify-content-center">
      <Col className="my-2" style={{ minWidth: 400, maxWidth: "80vw", textAlign: "center" }}>
        <ButtonGroup>
          <Button variant={(tab === 'manual') ? 'primary' : 'outline-primary'} onClick={() => { setTab('manual'); setSubTab('market'); }}>Manual</Button>
          <Button variant={(tab === 'faq') ? 'primary' : 'outline-primary'} onClick={() => { setTab('faq'); setSubTab('market'); }}>F.A.Q.</Button>
          <Button variant={(tab === 'prizes') ? 'primary' : 'outline-primary'} onClick={() => { setTab('prizes'); setSubTab('prizes'); }}>Prizes</Button>
          <Button variant={(tab === 'fairplay') ? 'primary' : 'outline-primary'} onClick={() => { setTab('fairplay'); setSubTab('rules'); }}>Fairplay</Button>
          <Button variant={(tab === 'nations') ? 'primary' : 'outline-primary'} onClick={() => { setTab('nations'); setSubTab('rules'); }}>Nationalities</Button>
          <Button variant={(tab === 'administration') ? 'primary' : 'outline-primary'} onClick={() => setTab('administration')}>Administration</Button>
          <Button variant={(tab === 'releaseNotes') ? 'primary' : 'outline-primary'} onClick={() => setTab('releaseNotes')}>Release Notes</Button>
          <Button variant={(tab === 'financing') ? 'primary' : 'outline-primary'} onClick={() => setTab('financing')}>Financing</Button>
          <Button variant={(tab === 'tutorials') ? 'primary' : 'outline-primary'} onClick={() => setTab('tutorials')} disabled>Tutorials</Button>
          {isAdmin(userInformation) || isDeveloper(userInformation) || isDevelopmentSupport(userInformation) ? 
            <Button variant={(tab === 'raceCalculation') ? 'primary' : 'outline-primary'} onClick={() => { setTab('raceCalculation'); setSubTab('calculation'); }}>🚧 Calculations 🛠</Button>
          : null }
        </ButtonGroup>
      </Col>
    </Row>
    {(() => {
      if (tab === 'manual')
        return <>
          <Row className="row d-flex justify-content-center">
            <Col className="col my-2" style={{ minWidth: 400, maxWidth: "80vw", textAlign: "center" }}>
              <ButtonGroup>
                <Button variant={(subTab === 'market') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('market')}>Transfermarket</Button>
                <Button variant={(subTab === 'races') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('races')}>Races</Button>
                <Button variant={(subTab === 'training') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('training')}>Training</Button>
                <Button variant={(subTab === 'stats') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('stats')}>Divisions</Button>
                <Button variant={(subTab === 'design') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('design')} disabled>Race Design</Button>
              </ButtonGroup>
            </Col>
          </Row>
          {(() => {
            if (subTab === 'market')
              return <>
                <div className="row d-flex justify-content-center">
                  <div className="col">
                    <h3>Transfermarket</h3>
                    <ol>
                      <li><b><HashLink smooth to='/manual/#market_team'>Creating a Team</HashLink></b>
                        <ul>
                          <li><HashLink smooth to='/manual/#market_autoteam'>Automatic Team</HashLink></li>
                          <li><HashLink smooth to='/manual/#market_individual'>Custom Team</HashLink></li>
                          <li><HashLink smooth to='/manual/#market_skills'>Rider Skills</HashLink></li>
                        </ul>
                      </li>
                      <li><b><HashLink smooth to='/manual/#market_buying'>Buying Riders</HashLink></b>
                        <ul>
                          <li><HashLink smooth to='/manual/#market_div67'><b>Division 6-7:</b> Buy-Now Market</HashLink></li>
                          <li><HashLink smooth to='/manual/#market_div15'><b>Division 1-5:</b> Auction Market</HashLink></li>
                          <li><HashLink smooth to='/manual/#market_youth'>Youth Riders</HashLink></li>
                          <li><HashLink smooth to='/manual/#market_naming'>Naming Riders</HashLink></li>
                        </ul>
                      </li>
                      <li><b><HashLink smooth to='/manual/#market_selling'>Selling Riders</HashLink></b>
                        <ul>
                          <li><HashLink smooth to='/manual/#market_salestax'>Sales Tax</HashLink></li>
                          <li><HashLink smooth to='/manual/#market_salespenalty'>Sales Penalty</HashLink></li>
                        </ul>
                      </li>
                      <li><b><HashLink smooth to='/manual/#market_reset'>Team Reset</HashLink></b>
                      </li>
                    </ol>
                    <h4 id="market_team">1. Creating a Team</h4>
                    <p>As a new team, or after a team-reset, you can either create an <b>automatic team</b> or <b>custom team.</b></p>
                    <h5 id="market_autoteam">Automatic Team</h5>
                    <p>This is recommended for newcomers. The automatic teams allow a quick start with a competitive team that can win races:</p>
                    <ol>
                      <li>You select a team type: Sprint Team, Climbing Team, Classics Team or Allround Team.</li>
                      <li>You receive 9 riders plus additional 2,500,000 - 5,000,000 budget for new transfers.</li>
                      <li>You choose the nationality and the name of each rider.</li>
                    </ol>
                    <p><b>How To:</b> Go to <Link to="/profile">Profile</Link>➝Auto-Team to find more information and generate your automatic team.</p>
                    <br />
                    <h5 id="market_individual">Custom Team</h5>
                    <p>This is recommended only for experienced managers. To have your own custom team setup, you can buy individual riders on the transfer market.</p>
                    <ol>
                      <li>It is recommended, that you buy at least 10 riders.</li>
                      <li>You can buy riders which were sold from other teams or you buy new riders without a nationality and without a name ("name geben" in German means "give him a name").</li>
                      <li>For those new riders, you choose the nationality and the name of each rider.</li>
                    </ol>
                    <p><b>How To:</b> Go to <Link to="/transfermarket">Market</Link> to search for riders and buy riders. Below you find more details on how the transfer market works.</p>
                    <h5 id="market_skills">Rider Skills</h5>
                    <p>The following table explains the different rider skills:</p>
                    <table className="table table-sm table-striped">
                      <thead>
                        <tr>
                          <th className="th-infotable" scope="col" style={{ textAlign: "left" }}>Symbol</th>
                          <th className="th-infotable" scope="col">Skill</th>
                          <th className="th-infotable" scope="col">Min</th>
                          <th className="th-infotable" scope="col">Max</th>
                          <th className="th-infotable" scope="col">Trainable</th>
                          <th className="th-infotable" scope="col">Description</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        <tr>
                          <td className="td-infotable"><img src={SkillClimbing} title="Climbing" alt="Climbing" /></td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>Climbing</td>
                          <td className="td-infotable">0</td>
                          <td className="td-infotable">100</td>
                          <td className="td-infotable">Yes</td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>Climbing skill is relevant on upward sloping kilometers. The steeper the gradient, the more important is climbing skill. From +1% to +3% it has a small relevance. On +4% it is roughly as important as flat skill. From +5% to +7% it tends to be more important than flat skill. From +8% it is the pre-dominant skill.</td>
                        </tr>
                        <tr>
                          <td className="td-infotable"><img src={SkillFlat} title="Flat" alt="Flat" /></td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>Flat</td>
                          <td className="td-infotable">0</td>
                          <td className="td-infotable">100</td>
                          <td className="td-infotable">Yes</td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>Flat skill is most relevant on kilometers between +3% and -3% gradient. As gradients get steeper, climbing skill and downhill skill become more relevant.</td>
                        </tr>
                        <tr>
                          <td className="td-infotable"><img src={SkillDownhill} title="Downhill" alt="Downhill" /></td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>Downhill</td>
                          <td className="td-infotable">0</td>
                          <td className="td-infotable">100</td>
                          <td className="td-infotable">Yes</td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>Downhill skill is relevant on downward sloping kilometers. The steeper the gradient, the more important is downhill skill. From -1% to -3% it has a small relevance. On -4% it is roughly as important as flat skill. From -5% to -7% it tends to be more important than flat skill. From -8% it is the pre-dominant skill.</td>
                        </tr>
                        <tr>
                          <td className="td-infotable"><img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" /></td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>Time Trial</td>
                          <td className="td-infotable">0</td>
                          <td className="td-infotable">100</td>
                          <td className="td-infotable">Yes</td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>TT skill is relevant for Indivdual Time Trials (ITT) and Team Time Trials (TTT). In this type of race, it is the most relevant skill on kilometers between +3% and -3% gradient. As gradients get steeper, climbing skill and downhill skill become more relevant.</td>
                        </tr>
                        <tr>
                          <td className="td-infotable"><img src={SkillSprint} title="Sprint" alt="Sprint" /></td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>Sprint</td>
                          <td className="td-infotable">0</td>
                          <td className="td-infotable">100</td>
                          <td className="td-infotable">Yes</td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>Sprint skill is relevant for Intermediate Sprints (IS), King of the Mountains (KOMs) and for the final sprint in a race (both in a mass sprint or in a sprint out of a smaller group of riders). The higher the value, the better the sprint. In any sprint, it is the most relevant skill on kilometers between +3% and -3% gradient. As gradients get steeper, climbing skill and downhill skill become more relevant for the sprint.</td>
                        </tr>
                        <tr>
                          <td className="td-infotable"><img src={SkillCobbles} title="Cobbles" alt="Cobbles" /></td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>Pavé</td>
                          <td className="td-infotable">0</td>
                          <td className="td-infotable">100</td>
                          <td className="td-infotable">Partially</td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>Pavé skill is relevant for kilometers with gravel or pavé sections. The more difficult a specific sector is (ranging from * to *****), the more relevant this skill will be. Also, this skill is a mixed calculation out of the hidden and non-trainable pavé-skill of a rider and the trainable flat skill: Pavé-Skill = Hidden-Pavé-Skill * 0.3 + Flat-Skill * 0.7 </td>
                        </tr>
                        <tr>
                          <td className="td-infotable"><img src={SkillRegeneration} title="Regeneration" alt="Regeneration" /></td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>Regeneration</td>
                          <td className="td-infotable">35</td>
                          <td className="td-infotable">65</td>
                          <td className="td-infotable">No</td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>Regeneration is relevant after a race. Each night, each rider recharges his energy by an amount equal to 10 * Regeneration.</td>
                        </tr>
                        <tr>
                          <td className="td-infotable"><b>Age</b></td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>Age</td>
                          <td className="td-infotable">20</td>
                          <td className="td-infotable">39</td>
                          <td className="td-infotable">No</td>
                          <td className="td-infotable" style={{ textAlign: "left" }}>In Cycling4Freaks, a season is 1 month. This means every month, every rider ages by one year. The maximum career length of a rider is 19 month. You can hire riders from the age of 20, but they are only allowed to ride races from 21 to 39. When they turn 40, they automatically retire. The younger a rider is, the better are his probabilities to train and improve his skills. From 21 to 32 they can improve their skills. From 33 to 39 they can only lose skills.</td>
                        </tr>
                      </tbody>
                    </table>
                    <h4 id="market_buying">2. Buying Riders</h4>
                    <p>On the transfer market, you can find a large variety of riders with different skillsets at different age. The market value of a rider always depends on his skillset.</p>
                    <h5 id="market_div67">Division 6-7: Buy-Now Market</h5>
                    <p>New teams in division 7 (until they have 1,500 points) and in division 6 (until promotion to div1-5) have their own transfer market to protect them from the costly fight for riders on the div1-5 auction market. In this protected market, you can directly buy riders without having to bid for them. Every few days, there is a refresh of the market, meaning that new riders will be available.</p>
                    <h5 id="market_div15">Division 1-5: Auction Market</h5>
                    <p>In Division 1-5 riders are sold in an auction. The price of each rider starts at 1000% of his market value and then decreases continuosly, until it reaches the minimum (95% of market value). There are two ways to buy a rider in auction:</p>
                    <ol>
                      <li><b>Buy Now:</b> Then of course the price can be quite high.</li>
                      <li><b>Bid:</b> Bid as much as you think you want to pay for a certain rider. You will see the date and time when the rider will reach this price. If there are no higher valid bids and you have enough money to cover your bid, the rider will then accept your offer and join your team.</li>
                    </ol>
                    <p>All bids are secret, you can only see your own bids. Unlike on the other transfer markets, here there is no complete refresh of the market, instead every few minutes a new riders joins the auction.</p>
                    <p>Riders that were sold by a team and appear on the Division 1-5 market are also sold in auctions. For these riders the minimum bid is 85%. When the rider's price has reached this limit, the rider stays on the market. The price then continues to decrease with different speed, depending on their age, down until 50%. Riders under 85% can be bought by "buy-now".</p>
                    <h5 id="market_youth">Youth Riders</h5>
                    <p>On both markets, you can buy riders at age 20. Effectively, these riders join your team only in the following month, as they have to be 21 years to be allowed to race. Just like all other riders, they will also stat training only as soons as they are 21. Nevertheless, this is a very common method of building your team because it ensures that you can train the rider over his whole career in the way you want to train him.</p>
                    <h5 id="market_naming">Naming Riders</h5>
                    <p>For all "name geben" riders ("give him a name"), you can choose the nationality and the name of each rider. Simply go to <Link to="/team">Team</Link> and click on the rider.</p>
                    <p>Please be aware that the Nationality Rules apply and you are asked to only give existing first and last names, or at least names that sound realistic for the selected nationality.</p>
                    <br />
                    <h4 id="market_selling">3. Selling Riders</h4>
                    <p>You can sell your riders at any time. When you sell a rider, you will however see your sales tax, which is higher the richer you are, and sales penalty, which exists for riders you have only bought very recently:</p>
                    <h5 id="market_salestax">Sales Tax</h5>
                    <p>To balance the chances between poor and rich teams, richer teams have to pay higher sales tax (up to 70%). The following formula applies:</p>
                    <p><b>Sales Tax = </b>10% + (Min(Total Capital,20M) - 15M)/5M * 10% + (Min(Total Capital,35M) - 20M)/15M * 50%</p>
                    <p>You can always view your own sales tax under <Link to="/transfermarket">Market</Link>➝SalesTax</p>
                    <h5 id="market_salespenalty">Sales Penalty</h5>
                    <p>To avoid extremely fast buying and selling of riders, there is a sales penalty (up to 50%) if you sell a rider within 50 days after buying him. The following formula applies:</p>
                    <p><b>Sales Penalty = </b>(50 - Min(Days in Team,50))* 1%</p>
                    <p>You can always view a rider's sales penalty under <Link to="/transfermarket">Market</Link>➝Own Riders➝Click on a Rider</p>
                    <br />
                    <h4 id="market_reset">4. Team Reset</h4>
                    <p>If your team value is below 20,000,000, or if you are simply unhappy with your curreny team, you can reset your team, if it fulfills the following criteria:</p>
                    <ul>
                      <li>Currently in Division 6</li>
                      <li>No recent reset (within last 15 days)</li>
                      <li>Not signed up for any race (You can un-inscribe in the Inscription-Page.)</li>
                      <li>No race today (If you had a race today, you can reset tomorrow.)</li>
                    </ul>
                    <p>After the reset you will have:</p>
                    <ul>
                      <li>0 riders in your team</li>
                      <li>20,000,000 start budget</li>
                      <li>the possibility to generate an automatic team (but can also buy riders on the market)</li>
                      <li>You keep your Profile Settings (Team Name, etc.) and your Palmarés.</li>
                      <li>But, you will have to wait at least 15 days until you can reset your team, again.</li>
                    </ul>
                    <p><b>How To:</b> Go to <Link to="/profile">Profile</Link>➝Reset to find more information and do your reset.</p>
                  </div>
                </div>
              </>
            if (subTab === 'races')
              return <>
                <div className="row d-flex justify-content-center">
                  <div className="col">
                    <h3>Live Races</h3>
                    <p>The live race is the main and special feature in this game! Every km you can adapt your tactics to the new situation. In the first phase of the race, 1 km takes 30 seconds. In the final phase of the race, 1 km takes 60 seconds to allow more time for setting your tactics. The below manual explains how to ride the races, but you can also ask in the <Link to="/chat">Chat</Link> or in the <a href="http://www.radsportfreaks.de/RSFForum" target="_blank" rel="noreferrer">Forum</a>. The community is generally friendly and provides explanations to newcomers.</p>
                    <ol>
                      <li><b><HashLink smooth to='/manual/#races_inscribe'>Inscribing to a live race</HashLink></b>
                        <ul>
                          <li><HashLink smooth to='/manual/#races_inscription'>Inscription</HashLink></li>
                          <li><HashLink smooth to='/manual/#races_fairplay'>Fairplay</HashLink></li>
                          <li><HashLink smooth to='/manual/#races_license'>License</HashLink></li>
                          <li><HashLink smooth to='/manual/#races_wcs'>World Championships</HashLink></li>
                          <li><HashLink smooth to='/manual/#races_ccs'>Continental Championships</HashLink></li>
                          <li><HashLink smooth to='/manual/#races_ncs'>National Championships</HashLink></li>
                        </ul>
                      </li>
                      <li><b><HashLink smooth to='/manual/#races_ride'>Riding a live race</HashLink></b>
                        <ul>
                          <li><HashLink smooth to='/manual/#races_tempo'>Making Tempo</HashLink></li>
                          <li><HashLink smooth to='/manual/#races_advancedtempo'>Advanced Tempo Settings</HashLink></li>
                          <li><HashLink smooth to='/manual/#races_attack'>Attacking</HashLink></li>
                          <li><HashLink smooth to='/manual/#races_follow'>Following</HashLink></li>
                          <li><HashLink smooth to='/manual/#races_help'>Helping</HashLink></li>
                          <li><HashLink smooth to='/manual/#races_fight'>Fighting</HashLink></li>
                          <li><HashLink smooth to='/manual/#races_iskom'>IS/KOM Sprints</HashLink></li>
                          <li><HashLink smooth to='/manual/#races_sprint'>Final Sprint</HashLink></li>
                          <li><HashLink smooth to='/manual/#races_stages'>Special Race Types (ITT/TTT/Half Stages)</HashLink></li>
                          <li><HashLink smooth to='/manual/#races_classifications'>Classifications</HashLink></li>
                        </ul>
                      </li>
                    </ol>
                    <h4 id="races_inscribe">1. Inscribing to a live race</h4>
                    <p>Every day the game offers multiple live races at different times. The whole calendar can be found in the <Link to="/calendar">Calendar</Link> tab and generally follows the races taking place in real life. </p>
                    <h5 id="races_inscription">Inscription</h5>
                    <p>You can sign up for a race until 30 minutes before the start. What is important to know before you sign up:</p>
                    <ul>
                      <li>It is an online game. To be successful, sign up for a time, at which you can be online.</li>
                      <li>Make sure, that you have registered all necessary riders (visible as "My inscribed Riders: 9 / 9" for example).</li>
                      <li>By inscribing to a race, you accept the <a className="page-links" onClick={() => { setTab('fairplay'); }}>Fairplay Rules</a>.</li>
                    </ul>
                    <h5 id="races_fairplay">Fairplay</h5>
                    <p>To ensure fair tactics and realistic gameplay, there are some <a className="page-links" onClick={() => { setTab('fairplay'); }}>Fairplay Rules</a> which you should adhere to during the live race.</p>
                    <h5 id="races_license">License</h5>
                    <p>If you have played the game before 2022, you might remember that you had to pay for a license to be able to ride one race per day. Currently all races are free for every player. We continue to offer only one race per day per team to ensure fair conditions. In the future, a license with additional features may be offered to players again as we develop more and more features.</p>
                    <h5 id="races_wcs">World Championships</h5>
                    <ul>
                      <li>Inscription starts on the 1st of the calendar month, in which the World Championships take place, but at the earliest 14 days before the first World Championship race.</li>
                      <li>The order, in which users get enabled for national team selection, is based on the previous month season ranking.</li>
                      <li>After the month change, you can see your selection time under: Statistics / Users / Selection Rank, Selection From</li>
                      <li>You can select a national team under: Statistics / Country / Click on a country</li>
                      <li>Then, you can inscribe your national team and its riders via the normal inscription</li>
                    </ul>
                    <h5 id="races_ccs">Continental Championships</h5>
                    <ul>
                      <li>Inscription starts on the 1st of the calendar month, in which the Continental Championships take place, but at the earliest 7 days before the first Continental Championships race.</li>
                      <li>If the last race of a World Championship and the first race of a Continental Championship fall into the same calendar month, or are less than 7 days apart, there will be no separate selection period for the Continental Championships and national team selection from the World Championships prevails.</li>
                      <li>Otherwise, the same inscription process, as described for the World Championships, applies.</li>
                      <li>It is only allowed to inscribe to a Continental Championship if your nation belongs to this continent.</li>
                      <li>In any case, only riders from such nations will be eligible to wear the jersey of the winner of the Continental Championship</li>
                    </ul>
                    <h5 id="races_ncs">National Championships</h5>
                    <p>All active riders are automatically inscribed into National Championships and can race on NC day.</p>
                    <br />
                    <h4 id="races_ride">2. Riding a live race</h4>
                    <h5 id="races_tempo">Making Tempo</h5>
                    <p>For each rider, you can set tempo (or no tempo) in three different intensities (high, medium, low) in the race screen.</p>
                    <ul>
                      <li><b>Tempo:</b> Click on the Tempo-Button in the race.</li>
                      <ul>
                        <li>The rider will make tempo in his current group and contribute to the speed of the group.</li>
                      </ul>
                      <li><b>Intensity:</b> Use the l/m/h-Button in the race.</li>
                      <ul>
                        <li><span style={{ color: "red" }}><b>High:</b></span> The rider goes 100% and spends up to 40 energy per km.</li>
                        <li><span style={{ color: "blue" }}><b>Medium:</b></span> The rider goes slower and spends ~70% energy.</li>
                        <li><span style={{ color: "green" }}><b>Low:</b></span> The rider goes slower and spends ~40% energy.</li>
                      </ul>
                    </ul>
                    <p>Tempo always costs energy. If multiple riders make tempo in the same group, the energy cost per rider per km declines. The cost of the tempo is always relative to the energy the rider still has, e.g. 1 km tempo with 1000 energy will cost much more energy than 1 km tempo with 100 energy.</p>
                    <p>Tempo can fail. If one or multiple stronger riders push your rider out of tempo, he will not contribute even though he is trying. But he will still lose ~60% of the energy he would lose if he was successfully making tempo.</p>
                    <br />
                    <h5 id="races_advancedtempo">Advanced Tempo Settings</h5>
                    <p>In some race situations, the advanced tempo settings in the Tactics-Screen can be useful:</p>
                    <ul>
                      <li><b>Tempo</b></li>
                      <ul>
                        <li><b>Normal:</b> The rider makes tempo and will ride together with other riders if they have a similar strength.</li>
                        <li><b>Shared:</b> The rider makes tempo together with all other riders in tempo.</li>
                        <li><b>Alone:</b> The rider makes tempo and pushes out all other riders if he is the strongest rider.</li>
                      </ul>
                      <li><b>Action</b></li>
                      <ul>
                        <li><b>WaitForLeader:</b> The rider waits for the teammate he is helping.</li>
                        <li><b>DropFromGroup:</b> The rider drops a few seconds back from his current group.</li>
                        <li><b>StartWhenDropped:</b> The rider will start making tempo in case he gets dropped from his current group.</li>
                      </ul>
                      <li><b>Until</b></li>
                      <ul>
                        <li><b>Indefinite:</b> The rider will continue until you set no tempo.*</li>
                        <li><b>Dropped:</b> The rider makes tempo until he gets dropped from his current group.</li>
                        <li><b>ReachPeloton:</b> The rider makes tempo until he reaches the biggest group, then he stops tempo.</li>
                        <li><b>ReachFront:</b> The rider makes tempo until he reaches the front group, then he stops tempo.</li>
                      </ul>
                    </ul>
                    <p>*If you are offline in one-day-races the rider will stop tempo after 15km.</p>
                    <h5 id="races_attack">Attacking</h5>
                    <ul>
                      <li><b>Attack:</b> Click on the Button in the Att.-Column in the race. It will display the km and intensity of the upcoming attack.</li>
                      <ul>
                        <li>The rider will attack next km and try to get in front of his current group.</li>
                      </ul>
                      <li><b>Intensity:</b> Click on the l/m/h-Button in the race.</li>
                      <ul>
                        <li><span style={{ color: "red" }}><b>High:</b></span> The rider attacks as fast as he can and spends up to 110 energy.</li>
                        <li><span style={{ color: "blue" }}><b>Medium:</b></span> The rider attacks at medium speed and spends less energy.</li>
                        <li><span style={{ color: "green" }}><b>Low:</b></span> The rider attacks at low speed and spends little energy.</li>
                      </ul>
                    </ul>
                    <p>An unsuccessful attack costs some energy, too. After a successful attack, the rider will automatically make tempo.</p>
                    <h5 id="races_follow">Following</h5>
                    <p>Select the rider you want to follow in case of an attack. You can use the little tool next to the riders start number ({'\uD83D\uDEE0'}) in the Race-Screen or the settings in the Tactics-Screen. The rider will follow the selected rider, if and when he attacks, but only if he is strong enough to do so.</p>
                    <p>The energy cost of a follower can be between 66% and 115% of the energy cost of the attacker, depending on 1) the intensity of the attack and 2) the strength difference between the attacker and the follower. If your rider is not strong enough to follow, he will stay in his current group and he will still lose some energy for the attempt to follow.</p>
                    <h5 id="races_help">Helping</h5>
                    <p>By helping you can keep riders of your team fit, minimize their energy loss and increase their chances in the decisive km of the race. Select the teammate your rider shall help. You can use the little tool next to the riders start number ({'\uD83D\uDEE0'}) in the Race-Screen or the settings in the Tactics-Screen.</p>
                    <p>The helped rider will lose less energy, while the supporting rider will lose more energy of course. The first support rider has a fairly big effect, a second support rider a smaller supplementary effect. Further support riders don’t help the leader directly, but share the work and all support riders will lose less energy than if there were only 2. If the rider who gets the help is dropped, the support rider will wait for him automatically.</p>
                    <h5 id="races_fight">Fighting</h5>
                    <ul>
                      <li><b>Yes:</b> The rider will go 110% to stay in his group if the tempo is so high that he is danger to get dropped, e.g. on a climb or pavé sector. He will manage to stay in his group for longer, but it will cost him more energy.</li>
                      <li><b>No:</b> The rider will only go 100% to stay in his group, which means he will get dropped earlier. This setting can be useful if the tempo is high, but you prefer to save energy at that point in the race.</li>
                    </ul>
                    <h5 id="races_iskom">IS/KOM Sprints</h5>
                    <p>The IS/KOM sprint is calculated within the normal race at the respective km.</p>
                    <ul>
                      <li><b>Launch:</b> The rider will start his sprint at 500 meters.</li>
                      <li><b>450m - 50m:</b> The rider will start his sprint at the respective mark.</li>
                    </ul>
                    <p>You can also help teammates or follow other riders:</p>
                    <ul>
                      <li><b>Help:</b> The rider will lead the teammate until the teammate launches his sprint.</li>
                      <li><b>Follow:</b> The rider will follow another rider until he launches his sprint.</li>
                    </ul>
                    <p>The energy cost for sprinting depends on how much energy the rider currently has.</p>
                    <p>The result of the IS/KOM sprints is calculated in the following way:</p>
                    <ol>
                      <li><b>Skills:</b> The sprint skill of a rider is the most important for the sprint, but climbing-/downhill-skill affect the sprint if the respective km is uphill/downhill. The steeper it is, the higher the effect.</li>
                      <li><b>Energy:</b> The higher the energy, the stronger the sprint.</li>
                      <li><b>Luck:</b> Each riders receives a random malus of 0-6 to his sprint-skill value.</li>
                      <li><b>Distance:</b> Sprinting from 500 meters doesn't give you a malus, for every 50 meters later the sprinter gets a 1 point malus on his sprint skill.</li>
                      <li><b>Help:</b> If a rider follows a teammate, he gets a bonus of 1/10 of the other rider’s sprint skill. This is guaranteed if your helping settings are logical, i.e. the rider who is helping his teammate launches the sprint earlier than him.</li>
                      <li><b>Successful Follow:</b> If a rider successfully follows another rider, he gets a bonus of 1/10 of the other rider’s sprint skill.</li>
                      <li><b>Unsuccessful Follow:</b> If a rider is unsuccessful in following another rider, he still gets a bonus of 3/10 of the other rider’s sprint skill.</li>
                    </ol>
                    <p>Beware, a rider can't follow another rider in the sprint if he attacked or attempted to attack in that km.</p>
                    <h5 id="races_sprint">Final Sprint</h5>
                    <p>The final sprint takes place in 10 steps from 500m to 0m. Each 50m, you will see the current status of the live sprint on the road and you can change your settings. The position on the road depends on the settings:</p>
                    <p>For the first 50m (from 500m to 450m), you have the same options as in an IS/KOM sprint. Afterwards, you will the live sprint and can adapt your settings with the following options:</p>
                    <ul>
                      <li><span style={{ color: "red" }}><b>Lose:</b></span> The rider will give up and make room for all others in the sprint.</li>
                      <li><b>Follow:</b> The riders tries to go in the slipstream of the rider he has set in "follow", or behind one of his helping teammates if one of these sprints. The latter is how you can build sprint-trains with own riders.</li>
                      <li><span style={{ color: "green" }}><b>Sprint Left:</b></span> The rider sprints. If a rider stand in his way, he turns to his left side.</li>
                      <li><span style={{ color: "green" }}><b>Sprint Right:</b></span> The rider sprints. If a rider stand in his way, he turns to his right side.</li>
                    </ul>
                    <p>The energy cost for the final sprint depends on how much energy the rider has before the sprint. It can be between 50 and 140 energy. Then, during the sprint, you will see a rider’s “sprint energy”. The “sprint energy” initially depends on his normal energy, but then moves independent from his normal energy. It is common to see the “sprint energy” drop quickly, even though the normal energy cost won’t be that high.</p>
                    <h5 id="races_stages">Special Race Types (ITT/TTT/Half Stages)</h5>
                    The game offers one-day races as well as stage races (meaning Tours over multiple days), just like in real life.
                    <ul>
                      <li><b>Regular Races:</b> Teams and Riders start in one peloton. Tempo and Attacks can split the peloton and/or the winner will come from the final sprint.</li>
                      <li><b>Individual Time Trial (ITT):</b> Each rider is on hiws own and rides against the clock for the win.</li>
                      <li><b>Team Time Trial (TTT):</b> Each time rides together against the clock.</li>
                      <li><b>Half Stages:</b> During some stage races, there are half stages, in which two stages happen on one day. There is a 5-minute break in between and riders receive 2*Regeneration as new energy.</li>
                    </ul>
                    <b>Making Tempo in Individual Time Trials (ITT)</b>
                    <p>For each rider, you can choose between 75% and 100% tempo. You can also choose whether the rider goes low, medium or high risk.</p>
                    <ul>
                      <li><span style={{ color: "red" }}><b>Risk, High:</b></span> Each km, the rider risks a lot, so he can gain (or lose) a few seconds.</li>
                      <li><span style={{ color: "blue" }}><b>Risk, Medium:</b></span> The rider takes less risk and his speed is more constant.</li>
                      <li><span style={{ color: "green" }}><b>Risk, Low:</b></span> The rider takes as little risk as possible and his speed is very constant.</li>
                    </ul>
                    <b>Making Tempo in Team Time Trials (TTT)</b>
                    <p>You can set the relative Tempo of each rider:</p>
                    <ul>
                      <li><span style={{ color: "red" }}><b>High:</b></span> The rider has the highest share of tempo amongst his teammates.</li>
                      <li><span style={{ color: "blue" }}><b>Medium:</b></span> The rider has a medium share of tempo, so his actual share will heavily depend on his teammates' settings.</li>
                      <li><span style={{ color: "green" }}><b>Low:</b></span> The rider has a low share of tempo, so his actual share will heavily depend on his teammates' settings.</li>
                      <li><span><b>None:</b></span> The rider has the lowest share of tempo amongst his teammates.</li>
                    </ul>
                    <p>So, as an extreme example, all riders on "high" is the same as all riders on "None".</p>
                    <p>You also have to select, whether teammates should wait for a specific rider or not. This is very important because the 5th rider of each team counts, so you should always try to keep at least 5 riders together in one group.</p>
                    <ul>
                      <li><b>Wait, Yes:</b> The teammates will always wait for this rider, even if the set tempo is too high for him. In that case, your team will lose some seconds (but keep that rider in the group).</li>
                      <li><b>Wait, No:</b> The teammates do not for this rider in case the tempo is too high for him. He will get dropped.</li>
                    </ul>
                    <p>Furthermore you can set "give all" for each riders</p>
                    <ul>
                      <li><b>Give all, Yes:</b> The rider will go 100%, as fast as he can, when he is making tempo.</li>
                      <li><b>Give all, No:</b> The rider will go slightly slower, a more controlled effort, when he is making tempo and lose a little bit less energy.</li>
                    </ul>
                    <h5 id="races_classifications">Classifications</h5>
                    <p>In stage races (Tours), there are several classifications:
                    </p>
                    <ul>
                      <li>General Classification (GC)<img alt="GC" src='https://upload.wikimedia.org/wikipedia/commons/2/29/Jersey_yellow.svg' style={{ maxHeight: "18px", marginBottom: 1 }} /></li>
                      <li>Points Classification<img alt="Points" src='https://upload.wikimedia.org/wikipedia/commons/c/c5/Jersey_green.svg' style={{ maxHeight: "18px", marginBottom: 1 }} /></li>
                      <li>Mountain Classification<img alt="Mountain" src='https://upload.wikimedia.org/wikipedia/commons/e/e1/Jersey_polkadot.svg' style={{ maxHeight: "18px", marginBottom: 1 }} /></li>
                      <li>Youth Classification<img alt="Youth" src='https://upload.wikimedia.org/wikipedia/commons/0/07/Jersey_white.svg' style={{ maxHeight: "18px", marginBottom: 1 }} /></li>
                      <li>Team Classification<img alt="Team" src='https://upload.wikimedia.org/wikipedia/commons/d/d1/Jersey_yellow_number.svg' style={{ maxHeight: "18px", marginBottom: 1 }} /></li>
                      <li>Combativity Award<img alt="Combativity" src='https://upload.wikimedia.org/wikipedia/commons/2/2f/Jersey_red_number.svg' style={{ maxHeight: "18px", marginBottom: 1 }} /></li>
                    </ul>
                    <p>For each race, you will find more details about the jerseys and the classifications in the calendar if you click on a race.</p>
                  </div>
                </div>
              </>
            if (subTab === 'training')
              return <>
                <div className="row d-flex justify-content-center">
                  <div className="col">
                    <h3>Training & Form</h3>
                    <ol>
                      <li><b><HashLink smooth to='/manual/#races_training'>Training Settings</HashLink></b></li>
                      <li><b><HashLink smooth to='/manual/#races_form'>Form Settings</HashLink></b></li>
                    </ol>
                    <h5 id="races_training">Training Settings</h5>
                    <p>The training takes place each 5th, 12th, 20th and 27th of each month at 0:40 CET.</p>
                    <p>For each rider, you have 7 training slots. If you change the trained skill in a slot, the training probabilities will adjust. The percentages indicate the probability that the rider trains up or down in the respective skill.</p>
                    <h5 id="races_form">Form Settings</h5>
                    <p>For each rider, you can select the climax of his form for the next month. On this day, the rider will reach peak form (100). The form cycle works the following way: Prior to peak form and after peak form, for each day, the form will decline by 1 until it reaches 85 and then goes back up again. A form of 100 represents a bonus of +2 on each riding skill (MO, FL, DH, TT, SP), while a form of 85 represents a malus of -2.</p>
                    <p>Alternatively, you can leave the form of a rider “constant”, in which case it will be 90.625 for the whole month.</p>
                  </div>
                </div>
              </>
            if (subTab === 'stats')
              return <>
                <div className="row d-flex justify-content-center">
                  <div className="col">
                    <h3>Divisions & Statistics</h3>
                    <ol>
                      <li><b><HashLink smooth to='/manual/#divisions_divisions'>Divisions</HashLink></b></li>
                      <li><b><HashLink smooth to='/manual/#divisions_statistics'>Statistics</HashLink></b></li>
                    </ol>
                    <h5 id="divisions_divisions">Divisions</h5>
                    <p>In each race, teams can earn <i>C4F Points</i> which are the basis for the Division Ranking. The Ranking is mostly for fun and prestige, but it is also relevant for a few details in the game:</p>
                    <ul>
                      <li><b>Transfermarket:</b> Div 1-5 and Div 6-7 have separate transfer markets (see chapter Transfermarket in this manual).</li>
                      <li><b>Race Groups:</b> If more than 22 teams are signed up for a race, the race is split into two groups according to the division ranking.</li>
                      <li><b>Races for limited Divisions:</b> Some races might be limited to specific divisions, e.g. to allow relatively new teams a fight amongst themselves without large, rich and experience teams.</li>
                      <li><b>World Championships:</b> When WCs take place, a higher ranking means that you have an earlier choice on which nation you want to lead as a manager.</li>
                    </ul>
                    <p>This how the divisions work: Divisions 1-6 have a promotion/relegation system. The promotion ranks (green) and relegation ranks (red) are shown under Statistics. Promotions and relegations generally happen with the month change, but teams in division 7 will be promoted to division 6 as soon as they reach 1,500 eternal points.</p>
                    <h5 id="divisions_statistics">Statistics</h5>
                    <p>In addition to the division system, the game offers lots of statistics. Some are published on the Statistics-Page and some are published by users in the Forum. Have fun and contribute if you have a nice idea!</p>
                  </div>
                </div>
              </>
          })()}
        </>
      if (tab === 'faq')
        return <>
          <div className="row d-flex justify-content-center">
            <div className="col my-2" style={{ minWidth: 400, maxWidth: "80vw", textAlign: "center" }}>
              <ButtonGroup>
                <Button variant={(subTab === 'market') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('market')}>Transfermarket</Button>
                <Button variant={(subTab === 'races') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('races')}>Race</Button>
                <Button variant={(subTab === 'finance') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('finance')}>Finance</Button>
                <Button variant={(subTab === 'other') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('other')}>Other</Button>
                <Button variant={(subTab === 'design') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('design')} disabled>Race Design</Button>
              </ButtonGroup>
            </div>
          </div>
          {(() => {
            if (subTab === 'market')
              return <>
                <div className="row d-flex justify-content-center">
                  <div className="col">
                    <h3>F.A.Q. Transfermarket</h3>
                    <ul>
                      <li><HashLink smooth to='/manual/#faq_tm_1'>What are the best possible skills for youth riders?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_tm_2'>How many youth riders can I buy?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_tm_3a'>What are the limitations for buying riders in terms of skills?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_tm_3b'>What are the limitations for buying young riders in terms of skills?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_tm_4'>Can I set form for my youth rider?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_tm_5'>When do riders retire?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_tm_6'>When exactly does the transfermarket refresh?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_tm_7'>I observed a rider on the youth market but now he disappeared. What happened?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_tm_8'>On the season/month change, what happens to youth riders?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_tm_9'>Can I sell a rider during a stage race/tour?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_tm_10'>How many riders can a team have?</HashLink></li>
                    </ul>
                    <h5 id="faq_tm_1">What are the best possible skills for youth riders?</h5>
                    <p>
                      <b>Best CL: </b>73, with best theoretically possible skills 73-56-79-54-59, 64reg (for each climbing skill less, the TT skill can be max. 3 higher)<br />
                      <b>Best FL: </b>74, with best theoretically possible skills 56-74-79-77-66, 64reg<br />
                      <b>Best TT: </b>77, with best theoretically possible skills 56-74-79-77-66, 64reg<br />
                      <b>Best SP: </b>82, with best theoretically possible skills 50-59-79-59-82, 64reg<br />
                    </p>
                    <h5 id="faq_tm_2">How many youth riders can I buy?</h5>
                    <p>The transfermarket system will only allow a specified number of youth riders. The way it works it, that the following 4 conditions always have to be fulfilled.</p>
                    <p>
                      <b>20 year-olds: </b>max. 4 riders<br />
                      <b>21 year-olds: </b>max. 4 riders<br />
                      <b>21-22 year-olds: </b>max. 5 riders<br />
                      <b>21-23 year-olds: </b>max. 6 riders<br />
                    </p>
                    <p>All four conditions have to satisfied at any time. For example, if you already have 4x 21-year-old, 1x 22-year-old and 1x 23-year-old, you will only be able to buy 1x 20-year-old.</p>
                    <h5 id="faq_tm_3a">What are the limitations for buying riders in terms of skills?</h5>
                    <p>To ensure realistic team building and somewhat balanced teams, there are some limites for the number of riders you can buy of a specific type:</p>
                    <ul>
                      <li>Max. 2 Climbers with ≥83 CL.</li>
                      <li>Max. 5 Climbers with ≥80 CL.</li>
                      <li>Max. 2 GC Riders with ≥77 CL & ≥69 TT.</li>
                      <li>Max. 2 Sprinters with ≥91 SP.</li>
                    </ul>
                    <p>Similarly, there are limits for buying young riders (under 24-years), see below</p>
                    <h5 id="faq_tm_3b">What are the limitations for buying young riders in terms of skills?</h5>
                    <ul>
                      <li>Max. 2 young Climbers with ≥71 CL.</li>
                      <li>Max. 5 young Climbers with ≥67 CL.</li>
                      <li>Max. 2 young GC Riders with ≥65 CL & ≥60 TT.</li>
                      <li>Max. 2 young Sprinters with ≥74 SP.</li>
                    </ul>
                    <h5 id="faq_tm_4">Can I set form for my youth rider?</h5>
                    <p>Form can only be set for ≥ 21-year-olds. This means that all 21-year-olds have 90.625 form.</p>
                    <h5 id="faq_tm_5">When do riders retire?</h5>
                    <p>In a team, a rider retires when he turns 40. On the transfer market, a rider retires when he turns 34.</p>
                    <h5 id="faq_tm_6">When exactly does the transfermarket refresh?</h5>
                    <p>The Div1-5 auction market refreshes constantly. This means, every few minutes, there will be a new rider. Every auction takes a few days, so it is enough to check the market every few days to view new riders.</p>
                    <p>The Div6-7 buy-now market refreshes every few days on a random basis. On average, the refresh happens every 4 days and it is guaranteed that the market refreshes at least after 6 days.</p>
                    <h5 id="faq_tm_7">I observed a rider on the youth market but now he disappeared. What happened?</h5>
                    <p>In the Div1-5 auction market, this means that somebody else won the bidding or that the auction ended without anybody buying the rider.</p>
                    <p>In the Div6-7 buy-now market, each refresh of the market means that all youth riders are new. If nobody bought a rider before a refresh, he will disappear on the refresh of the market.</p>
                    <h5 id="faq_tm_8">On the season/month change, what happens to youth riders?</h5>
                    <p>In the Div1-5 auction market, all riders age by 1 year per month, so the 20-year-old youth riders will simply turn 21. You can still buy them and they will directly be added to your team.</p>
                    <p>In the Div6-7 buy-now market, the youth market will refresh when the season/month changes.</p>
                    <h5 id="faq_tm_9">Can I sell a rider during a stage race/tour?</h5>
                    <p>No, as long as the rider is paricipating in a stage race/tour, you cannot sell him on the transfer market.</p>
                    <h5 id="faq_tm_10">How many riders can a team have?</h5>
                    <p>Each team can only have a maximum of 20 riders.</p>
                  </div>
                </div>
              </>
            if (subTab === 'races')
              return <>
                <div className="row d-flex justify-content-center">
                  <div className="col">
                    <h3>F.A.Q. Live Races</h3>
                    <ul>
                      <li><HashLink smooth to='/manual/#faq_race_0'>How long does a km take?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_1'>How does weather affect the race?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_2'>How can I change my team jersey?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_3a'>What is the time limit for dropped riders?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_3b'>What if I cannot be online for a race?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_4'>How many teams are necessary to have a split into two groups for one race?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_5'>What’s the Regeneration between two half stages?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_6'>What are the rules for the youth jersey if a stage race goes over the month change?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_7'>Can a rider attack with 0 energy?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_8'>Can a rider sprint with 0 energy?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_9'>What does the small traffic light (red, orange, green) in the "Refresh Race"-Button mean?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_10'>When exactly does the km change?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_11'>WCs/CCs - Can a rider ride the ITT and the Roadrace?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_12'>WCs/CCs - Can a country with less than 9 (4) riders ride the road race (ITT)? </HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_13'>WCs/CCs - Can I inscribe less than 9 (4) riders even so my country has more than 9 (4)?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_14'>WCs/CCs - Can I select one country for the ITT and switch afterwards to a country that is not picked already?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_race_15'>WCs/CCs - What will be the form and energy of the riders in my national team?</HashLink></li>
                    </ul>
                    <h5 id="faq_race_0">How long does a km take?</h5>
                    <p>Each km in the race takes 30 seconds. At some point, decided by the race designer, this will switch to 60 seconds per km to allow each player more time for making settings in the final phase of the race.</p>
                    <h5 id="faq_race_1">How does weather affect the race?</h5>
                    <p>
                      <b>Temperature: </b>High and low temperatures cost more energy. Around ~20 degress is ideal for riders.<br />
                      <b>Precipitation: </b>Sun and heavy rain cost more energy. Cloudy is ideal for riders. Heavy rain makes downhill and pavé sectors more selective.<br />
                      <b>Wind: </b> In a headwind, tempo costs slightly more energy. Following costs slightly less energy. In a tailwind, tempo costs slightly less energy. Following costs slightly more energy. In a crosswind, energy costs are higher for everyone.<br />
                    </p>
                    <h5 id="faq_race_2">How can I change my team jersey?</h5>
                    <p>Go to Profile ➝ Edit Jersey.</p>
                    <h5 id="faq_race_3a">What is the time limit for dropped riders?</h5>
                    <p>In one-day-races, riders will give up when they are 35min behind the front group of the race.</p>
                    <p>In stage races (tours), riders will be taken out of the race if they finish 45min behind the stage winner.</p>
                    <h5 id="faq_race_3b">What if I cannot be online for a race?</h5>
                    <p>In one-day-races, you cannot be offline for more than 60% of the race. For example, if you miss 120 consecutive km in a 200km race, your riders will abandon.</p>
                    <p>In stage races (tours), you can be offline for whole stages, but there is a limit. If you miss more than 60% of the race in more than 60% of the stages, your riders will abandon.</p>
                    <h5 id="faq_race_4">How many teams are necessary to have a split into two groups for one race?</h5>
                    <p>The maximum number of teams is 22. So if there are 23 teams or more, there will be two races (group 1 and group 2). The split is based on the division and the ranking within the division. Group 2 will still earn 70% of the prize money points.</p>
                    <h5 id="faq_race_5">What’s the Regeneration between two half stages?</h5>
                    <p>Each rider will receive 2x his Regeneration value as energy.</p>
                    <h5 id="faq_race_6">What are the rules for the youth jersey if a stage race goes over the month change?</h5>
                    <p>Only the age at the end of the stage race / tour is relevant for the youth classement.</p>
                    <h5 id="faq_race_7">Can a rider attack with 0 energy?</h5>
                    <p>No.</p>
                    <h5 id="faq_race_8">Can a rider sprint with 0 energy?</h5>
                    <p>Yes, but his sprint will be very slow of course.</p>
                    <h5 id="faq_race_9">What does the small traffic light (red, orange, green) in the "Refresh Race"-Button mean?</h5>
                    <p>The traffic light shows, whether a request to the server (for example, your new settings or the race refresh) have worked or not. Normally, the traffic light will always be green. Only if you make settings exactly at the time of the km-change, the traffic light may be red. So make sure that you make your settings early enough.</p>
                    <h5 id="faq_race_10">When exactly does the km change?</h5>
                    <p>To limit the effect of so-called "sec-tricks", where players change tempo immediately before the km-change, each km change has a random delay. At half-minute km (:30), the delay is between 3s and 5s. At full-minute km (:00), the delay is between 2s and 8s.</p>
                    <h5 id="faq_race_11">WCs/CCs - Can a rider ride the ITT and the Roadrace?</h5>
                    <p>Yes.</p>
                    <h5 id="faq_race_12">WCs/CCs - Can a country with less than 9 (4) riders ride the road race (ITT)?</h5>
                    <p>Yes.</p>
                    <h5 id="faq_race_13">WCs/CCs - Can I inscribe less than 9 (4) riders even so my country has more than 9 (4)?</h5>
                    <p>Yes.</p>
                    <h5 id="faq_race_14">WCs/CCs - Can I select one country for the ITT and switch afterwards to a country that is not picked already?</h5>
                    <p>Yes.</p>
                    <h5 id="faq_race_15">WCs/CCs - What will be the form and energy of the riders in my national team?</h5>
                    <ul>
                    <li>Form will be the normal monthly form set (or not set) by the team manager</li>  
                    <li>Energy will be 1000 for each rider participating in a race</li>  
                    </ul>
                  </div>
                </div>
              </>
            if (subTab === 'finance')
              return <>
                <div className="row d-flex justify-content-center">
                  <div className="col">
                    <h3>F.A.Q. Finances</h3>
                    <ul>
                      <li><HashLink smooth to='/manual/#faq_finance_1'>What is the budget for every race?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_finance_2'>How can I calculate the value and salary of a rider?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_finance_3'>What happens if my finances go negative?</HashLink></li>
                    </ul>
                    <h5 id="faq_finance_1">What is the covered salary for every race?</h5>
                    <p>For each race day, you have a covered salary, which depends on the number of riders per team:</p>
                    <p>
                      <b>9 riders: </b>375,000<br />
                      <b>8 riders: </b>335,000<br />
                      <b>7 riders: </b>295,000<br />
                      <b>6 riders: </b>255,000<br />
                      <b>5 riders: </b>215,000<br />
                      <b>4 riders: </b>175,000<br />
                      <b>3 riders: </b>135,000<br />
                      <b>2 riders: </b>95,000<br />
                      <b>1 rider: </b>55,000<br />
                    </p>
                    <p>Any salary above the covered salary will have to be paid by yourself.</p>
                    <h5 id="faq_finance_2">How can I calculate the value and salary of a rider?</h5>
                    <p>In general, the higher a rider’s skills are, the higher his value and salary. Age affects only the value (not the salary) and youth riders will be worth more than old riders, if they have the same skills.</p>
                    <h5 id="faq_finance_3">What happens if my finances go negative?</h5>
                    <p>At first, nothing happens, but if you fall to -100,000, you can no longer inscribe to a race. If this happens to you, you can sell a rider (or in the worst case, reset your team) to get back above the limit of -100,000.</p>
                  </div>
                </div>
              </>
            if (subTab === 'other')
              return <>
                <div className="row d-flex justify-content-center">
                  <div className="col">
                    <h3>F.A.Q. Other Topics</h3>
                    <ul>
                      <li><HashLink smooth to='/manual/#faq_other_0'>How many races can I rider per day?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_other_1'>What is a mentor and where can I get a mentor?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_other_2'>When exactly does the daychange take place?</HashLink></li>
                      <li><HashLink smooth to='/manual/#faq_other_3'>How are the season points calculated for each team in the division ranking?</HashLink></li>
                    </ul>
                    <h5 id="faq_other_0">How many races can I rider per day?</h5>
                    <p>To ensure a fair game, in which you dont have to be online 24/7 to be successful, every player can only ride one race per day.</p>
                    <h5 id="faq_other_1">What is a mentor and where can I get a mentor?</h5>
                    <p>A mentor is someone who helps you get started with this sometimes complicated game. He will explain strategies/tactics for teambuilding and racing. You can find someone in the forum in this thread or you ask someone in the general chat or race chat. Communication with your mentor usually happens via private messages in the forum, but you can choose whichever communication you like.</p>
                    <h5 id="faq_other_2">When exactly does the daychange take place?</h5>
                    <p>Between 3:00 and 4:00 CET every day.</p>
                    <h5 id="faq_other_3">How are the season points calculated for each team in the division ranking?</h5>
                    <p>The season points for each team are the sum of each of the team's riders. This means, if you sell (or buy) a rider with points, you will also lose (or gain) points in the division ranking.</p>
                  </div>
                </div>
              </>
          })()}
        </>
      if (tab === 'fairplay')
        return <>
          <div className="row d-flex justify-content-center">
            <div className="col my-2" style={{ minWidth: 400, maxWidth: "80vw", textAlign: "center" }}>
              <ButtonGroup>
                <Button variant={(subTab === 'rules') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('rules')}>Rules</Button>
                <Button variant={(subTab === 'fpc') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('fpc')}>FPC</Button>
              </ButtonGroup>
            </div>
          </div>
          {(() => {
            if (subTab === 'rules')
              return <div className="row d-flex justify-content-center">
                <div className="col">
                  <h3>Fairplay Rules</h3>
                  <ol>
                    <li><b><HashLink smooth to='/manual/#fairplay_inrace'>In-Race Fairplay</HashLink></b>
                      <ul>
                        <li><HashLink smooth to='/manual/#fairplay_teamattacks'>Prohibited Team Attacks</HashLink></li>
                        <li><HashLink smooth to='/manual/#fairplay_arrangements'>Unrealistic Arrangements</HashLink></li>
                        <li><HashLink smooth to='/manual/#fairplay_sitting'>Sitting</HashLink></li>
                      </ul>
                    </li>
                    <li><b><HashLink smooth to='/manual/#fairplay_language'>Offensive Language</HashLink></b>
                    </li>
                    <li><b><HashLink smooth to='/manual/#fairplay_cheating'>Technical Cheating</HashLink></b>
                    </li>
                  </ol>
                  <br />
                  <h4 id="fairplay_inrace">1. In-Race Fairplay</h4>
                  <p>To ensure fair tactics and realistic gameplay, there are some prohibited team attacks.</p>
                  <p>
                    <h5 id="fairplay_teamattacks">Prohibited team attacks:</h5>
                    <b>1&#41; Normal Team Attack:</b> Attack (not following) with more than 2 riders of one team at the same km out of the same group. This rule is deactivated for the last 10 km of every race.<br />
                    <b>2&#41; Combined Team Attack:</b> Attack (not following) with more than 5 riders of one team during 20 km out of the same group, if these riders end up in the same group. This rule is deactivated in the second half of every race.<br />
                    <b>3&#41; Chained Attacks:</b> Escape (attacking or following) with more than 2 riders of one team at the same km out of the same group. This rule is deactivated:<br />
                    - if ≥11 riders from ≥4 teams escape, or<br />
                    - if the original group has ≤14 riders, or<br />
                    - if there are ≤20 km left in the race, or<br />
                    - if the road incline is ≥4%.<br />
                  </p>
                  <h5 id="fairplay_arrangements">Unrealistic Arrangements:</h5>
                  <p>Unrealistic arrangements are not allowed. Every manager must do the best for his team. Separation of private and C4F is required.</p>
                  <h5 id="fairplay_sitting">Sitting:</h5>
                  <ul>
                    <li>Sitting is only permitted in stage races (prohibited for one-day races).</li>
                    <li>During stage races, it is mandatory to be online at least 20% of the stages (no sitter logged in during those stages).</li>
                    <li>It is prohibited to share your password with another team. Any case of password sharing will be treated like a multi account case.</li>
                  </ul>
                  <br />
                  <h4 id="fairplay_language">2. Offensive Language</h4>
                  <p>
                    This game may be played by minors. Therefore, players shall use appropriate and respectful language. Furthermore, users commit themselves to adapt their language and behavior to the laws and manners protecting minors.<br />
                  </p>
                  <p>
                    Each user commits himself not to use terms or names with racist, pornographic or sexist connotations or other offensive terms that are against good manners.
                  </p>
                  <p>
                    Direct and obvious insults, offensive language or harmful/offensive behavior will be sanctioned, including, but not limited to:
                  </p>
                  <ul>
                    <li>Bullying or harassment of other players without insulting them directly, e.g. by sending repeated threats, pejorative labels, hate speech, sexual remarks, or posting false statements as facts, aimed at discrediting or humiliating a targeted player;</li>
                    <li>Repeated usage of insulting Emojis or Ascii Symbols;</li>
                    <li>Defamatory false accusations of players in their role as a volunteer (Developer, FPC member, NC member, Calendar Manager, Race Designer or other role), in particular falsely accusing them of manipulations to their own advantage with the effect of harming the game’s reputation.</li>
                  </ul>
                  <p>
                    These rules apply to all means of communication concerning the game, including the race chat, spectator chat, general chat and the <a href="http://www.radsportfreaks.de/RSFForum" target="_blank" rel="noreferrer">Forum</a>.
                  </p>
                  <br />
                  <h4 id="fairplay_cheating">3. Technical Cheating</h4>
                  <p>
                    Technical cheating is forbidden, including, but not limited to:
                  </p>
                  <ul>
                    <li><b>Owning multiple accounts:</b>  It is prohibited to create more than one account per user to play the game. Multi accounts will be deleted.</li>
                    <li><b>Usage of VPNs:</b> To fight multi accounts, the use of browsers or extensions that let the user hide and change their IP constantly without plausible explanation is not allowed.</li>
                    <li><b>Usage of Bugs:</b> Using obvious or officially announced bugs in the game to gain an unfair advantage over other players is prohibited.</li>
                    <li><b>Direct or indirect manipulation of the game:</b> Any cheating by usage of technical means, including, but not limited to, hacking other players accounts or the game’s server is prohibited.</li>
                  </ul>
                </div>
              </div>
            if (subTab === 'fpc')
              return <div className="row d-flex justify-content-center">
                <div className="col">
                  <h3>Fairplay Committee &#40;FPC&#41;</h3>
                  <ol>
                    <li><b><HashLink smooth to='/manual/#fpc_summary'>Summary</HashLink></b>
                    </li>
                    <li><b><HashLink smooth to='/manual/#fpc_members'>Members</HashLink></b>
                    </li>
                    <li><b><HashLink smooth to='/manual/#fpc_mode'>Mode of Operation</HashLink></b>
                    </li>
                    <li><b><HashLink smooth to='/manual/#fpc_penalties'>Penalty Guidelines</HashLink></b>
                    </li>
                  </ol>
                  <br />
                  <h4 id="fpc_summary">1. Summary</h4>
                  <p>The FPC is the organization in C4F that is responsible for:</p>
                  <ul>
                    <li>Handling cases that affect the fair play in the game, most importantly violations of the rules;</li>
                    <li>Reading and responding in the fairplay section of the <a href="http://www.radsportfreaks.de/RSFForum" target="_blank" rel="noreferrer">Forum</a> and investigating accusations;</li>
                    <li>Interfering in the race chat if there is a fair play incident.</li>
                  </ul>
                  <h4 id="fpc_members">2. Members</h4>
                  <p>The FPC shall consist of players that have been found suitable for this role. For the moment, the following players are FPC members:</p>
                  {userRoles ?
                  <C4FSimpleTable key={'fpcRoles'}
                    initialSortingColumn={'role'}
                    initialSortingAscending={true}
                    hideColumnVisibility={true}
                    data={userRoles.filter((a) => a.role == 'FairplayCommittee')}
                    rowMetadata={[
                      { columnName: 'userName', columnDescription: 'User' },
                      { columnName: 'acronym', columnDescription: 'Acronym' },
                      { columnName: 'forumAccount', columnDescription: 'Forum Account' },
                      { columnName: 'role', columnDescription: 'Role' }
                    ]}
                  />
                  : null}
                  <p>The FPC members are neutral, objective and unbiased in every case that they handle. If a member is biased in any way, this member has the duty to withdraw from the case on the grounds of bias and will not be involved in any decision regarding the case.
                  </p>
                  <h4 id="fpc_mode">3. Mode of Operation</h4>
                  <p>FPC Members have several rights and duties to enforce fairplay rules. They may open a fairplay thread, moderate a fairplay thread, propose a penalty and vote for a penalty. The game developers generally follow the FPC discussions and execute its decisions in the database. They also preserve the right to halt, postpone or veto a decision in the exceptional case that it cannot be implemented technically or poses problems for the game’s existence or further development.</p>
                  <ul>
                    <li><b>Opening a fair play case:</b> Either a player or an FPC member opens a thread in the fair play section, which allows the accused player, as well as others, to comment.</li>
                    <li><b>Discussion:</b> Each FPC member can propose a decision/penalty and has the right to discuss the proposal and counter propose.</li>
                    <li><b>Hearing:</b> The FPC opens an ingame hearing for the involved parties in which they can give their opinion/view about the fairplay issue.</li>
                    <li><b>Voting:</b> Each FPC member has the duty to vote for a proposal. A proposal that gets the majority of votes will be the preliminary judgement. The result of the vote will not be made public.</li>
                    <li><b>Decison-Making:</b> As soon as possible, preferably within 7 days,a decision is made by the FPC internally and then communicated in the respective fair play thread. Exceptions are cases, when a fast decision is not possible due to extensive investigation.</li>
                    <li><b>Executing the decision:</b> The game’s developers generally follow the FPC discussions and execute its decisions in the database as soon as possible, preferably within 3 days. Some of the decisions are automated already &#40;bans, fines&#41; but others are not yet fully automated &#40;C4F points, In-Race Time/Points penaties&#41;</li>
                    <li><b>Appealing against a FPC decision:</b> After the decision has been communicated to the player and made public in the fair play thread, players have 3 days to appeal against it in the case-thread in the forum or in the ingame hearing. If nobody appeals, the decision remains in force. If there is an appeal, the FPC does another voting round as soon as possible, preferably within 7 days.</li>
                  </ul>
                  <h4 id="fpc_penalties">4. Penalty Guidelines</h4>
                  <p>A penalty &#40;or no penalty&#41; is decided by the proposals and the voting in the FPC. Nevertheless, there should be a frame in which a decision should be made according to the severity of the fair play breach and the players fair play history. As different players may have different opinions about penalties for certain fair play breaches, these guidelines will not be made publicly available but will serve the FPC for a better and fairer decision making &#40;prevention of arbitrariness and too much time-consuming discussion in the FPC decision making&#41;.</p>
                  <p>The following principles shall guide any decisions:</p>
                  <ul>
                    <li>Financial advantages gained from fair play breaches shall be reversed through a fine that exceeds the advantage gained.</li>
                    <li>Advantages gained unfairly in a race shall be reversed through time penalties or IS/KOM penalties, if that is possible in a timely manner during a stage race. In extreme cases, palmarés entries can be revoked.</li>
                    <li>Offensive language and technical cheating shall lead to fines and, in extreme cases, to bans.</li>
                    <li>If fair play violations are repeated, or if a player honestly &#40;believably&#41; regrets his fair play violation, that shall be considered in the decision making.</li>
                  </ul>
                </div>
              </div>
          })()}
        </>
      if (tab === 'nations')
        return <>
          <div className="row d-flex justify-content-center">
            <div className="col my-2" style={{ minWidth: 400, maxWidth: "80vw", textAlign: "center" }}>
              <ButtonGroup>
                <Button variant={(subTab === 'rules') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('rules')}>Guidelines</Button>
                <Button variant={(subTab === 'nc') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('nc')}>NC</Button>
              </ButtonGroup>
            </div>
          </div>
          {(() => {
            if (subTab === 'rules')
              return <div className="row d-flex justify-content-center">
                <div className="col">
                  <h3>Nationality Guidelines</h3>
                  <ol>
                    <li><b><HashLink smooth to='/manual/#nations_guidelines'>Guidelines for Naming Riders</HashLink></b></li>
                  </ol>
                  <br />
                  <h4 id="fairplay_inrace">1. Guidelines for Naming Riders</h4>
                  <p>The game strives for realistic gameplay and therefore, we ask all teams to give somewhat realistic names to their riders. The full guidelines are below:</p>
                  <b>§ 1 Principles of Naming Riders</b><br />
                  (1) All first names and last names should exist in reality or at least sound realistic.<br />
                  (2) A rider’s name has to fit the selected nationality.<br />
                  <b>§ 2 Prohibited Names</b><br />
                  (1) Nicknames, artist names (e.g. „Avicii“) or fantasy names (e.g. „Darth Vader“) are not allowed. Riders with such names will be made stateless.<br />
                  (2) It’s not allowed to alter names of real existing celebrities (sports, politics, music, films, etc.) either by adding, deleting or changing letters (e.g. "Wout VanArt" or "Matthieu VanDerPoel").<br />
                  (3) If it’s not possible to give a certain name, another first or last name is allowed (e.g. "Thomas VanDerPoel" is allowed, even if a bit random).<br />
                  <b>§ 3 Order of Names</b><br />
                  (1) First name and last name (family name) have to be given in the right order. If this is not the case, a rider will be made stateless (e.g. Müller Thomas instead of Thomas Müller).<br />
                  <b>§ 4 Change of Nationality</b><br />
                  (1) A user has maximum three times the possibility to change the rider’s nationality. If each time the user choses a non-fitting nationality, the NC will chose a fitting nationality.<br />
                  <b>§ 5 Rights and Duties of the Nations Committee (NC)</b><br />
                  (1) The NC’s Guidelines have to be executed consistently by the NC members.<br />
                  (2) The NC members have to participate in the NC’s work on a constant basis.<br />
                </div>
              </div>
            if (subTab === 'nc')
              return <div className="row d-flex justify-content-center">
                <div className="col">
                  <h3>Nations Committee &#40;NC&#41;</h3>
                  <ol>
                    <li><b><HashLink smooth to='/manual/#nc_summary'>Summary</HashLink></b>
                    </li>
                    <li><b><HashLink smooth to='/manual/#nc_members'>Members</HashLink></b>
                    </li>
                    <li><b><HashLink smooth to='/manual/#nc_mode'>Mode of Operation</HashLink></b>
                    </li>
                  </ol>
                  <br />
                  <h4 id="nc_summary">1. Summary</h4>
                  <p>The NC is the organization in C4F that is responsible for:</p>
                  <ul>
                    <li>Promoting realistic names in-game</li>
                    <li>Judging questionable names</li>
                    <li>Changing or revoking rider passports</li>
                  </ul>
                  <h4 id="nc_members">2. Members</h4>
                  <p>The NC shall consist of players that have been found suitable for this role. For the moment, these are the NC members:</p>
                  {userRoles ?
                <C4FSimpleTable key={'ncRoles'}
                  initialSortingColumn={'role'}
                  initialSortingAscending={true}
                  hideColumnVisibility={true}
                  data={userRoles.filter((a) => a.role == 'NationsCommittee')}
                  rowMetadata={[
                    { columnName: 'userName', columnDescription: 'User' },
                    { columnName: 'acronym', columnDescription: 'Acronym' },
                    { columnName: 'forumAccount', columnDescription: 'Forum Account' },
                    { columnName: 'role', columnDescription: 'Role' }
                  ]}
                />
                : null}
                  <p>The NC members are neutral, objective and unbiased in every case that they handle. If a member is biased in any way, this member has the duty to withdraw from the case on the grounds of bias and will not be involved in any decision regarding the case.
                  </p>
                  <h4 id="nc_mode">3. Mode of Operation</h4>
                  <p>NC Members have several rights and duties to promote realistic names in-game.</p>
                  <p>When a rider’s name is created and his nationality chosen, his name shows up in the list "new names". Each NC member has the following options to process a name from this list.</p>
                  <ul>
                    <li><b>OK:</b> The rider’s name is ok: it exists in reality or sounds realistic and fits to the given nationality. If three NC members click the OK button (names of NC members are visible on the list), the rider’s name is approved and will disappear from the this list.</li>
                    <li><b>Wrong Nationality:</b> If a NC members thinks that the rider’s name and nationality do not fit, this button may be clicked. The rider (name) disappears from the list "new names" and is now visible in the list "current applications". If the NC-member's application is not declined by another NC-member, it becomes effective after three days. The user affected then receives and automatic message and the possibility to chose another nationality.</li>
                    <li><b>No Name:</b> If a rider’s name on the list "new names" does not exist or does not sound realistic, this is the option to chose for the NC member. The rider affected will be stateless subsequently. The rider (name) disappears from the list "new names" and shows up in the list "current applications". If the NC-member's application is not declined by another NC-member, it becomes effective after three days. The user affected then receives and automatic message.</li>
                    <li><b>Clone:</b> If a rider’s name on the list is a so called „clone“ – a real existing name in an alternate form – this function may be used by the NC member. The rider affected will be stateless as with the “No name”-option. The rider (name) disappears from the list "new names" and shows up in the list "current applications". If the NC-member's application is not declined by another NC-member, it becomes effective after three days. The user affected then receives and automatic message.</li>
                    <li><b>Individual:</b>With this function a NC member can appoint a rider to another nationality or make him stateless while having the possibility to write a customised message to the user affected. This is also the case for an already processed name that has to be processed again (f.e. succesful appeal). If the NC-member's application is not declined by another NC-member, it becomes effective after three days. The user affected then receives the customised message.</li>
                  </ul>
                </div>
              </div>
          })()}
        </>
      if (tab === 'prizes')
        return <>
          <div className="row d-flex justify-content-center">
            <div className="col my-2" style={{ minWidth: 400, maxWidth: "80vw", textAlign: "center" }}>
              <ButtonGroup>
                <Button variant={(subTab === 'prizes') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('prizes')}>Money & Points</Button>
                <Button variant={(subTab === 'jerseys') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('jerseys')}>Jersey-Icons</Button>
                <Button variant={(subTab === 'jerseys2') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('jerseys2')}>Jerseys</Button>
              </ButtonGroup>
            </div>
          </div>
          {(() => {
            if (subTab === 'prizes')
              return <C4FPrizeMoney />
            if (subTab === 'jerseys')
              return <div className="row d-flex justify-content-center">
                <div className="col" style={{ maxWidth: 800 }}>
                  <h4>Leader Jerseys - Icons</h4>
                  <h5>Stage Races</h5>
                  <C4FSimpleTable key={'tourJerseyIcons'}
                  initialSortingColumn={'tourName'}
                  initialSortingAscending={true}
                  data={tourJerseyMapping
                    .map(record => ({
                      ...record,
                      GCLeaderJersey: <img alt="GCLeader" src={getJersey(record.tourName, 'GCLeader')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                      PointsJersey: <img alt="Points" src={getJersey(record.tourName, 'Sprint')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                      MountainJersey: <img alt="Mountain" src={getJersey(record.tourName, 'Mountain')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                      YouthJersey: <img alt="Youth" src={getJersey(record.tourName, 'Youth')} style={{ maxHeight: "18px", marginBottom: 1 }} />
                    }))}
                  rowMetadata={[
                    { columnName: 'tourName', columnDescription: 'Tour' },
                    { columnName: 'GCLeaderJersey', columnDescription: '--- GC ---', columnType: 'object' },
                    { columnName: 'PointsJersey', columnDescription: '- Points -', columnType: 'object' },
                    { columnName: 'MountainJersey', columnDescription: 'Mountain', columnType: 'object' },
                    { columnName: 'YouthJersey', columnDescription: '- Youth -', columnType: 'object' }
                  ]
                  }
                />
                <br/>
                <h5>National Champions</h5>
                <C4FSimpleTable key={'NCJerseyIcons'}
                  initialSortingColumn={'country'}
                  initialSortingAscending={true}
                  data={countries
                    .filter((a) => a.isRiderNationality)
                    .map(record => ({
                      ...record,
                      flag: getUnicodeFlag(record.countryCode),
                      NCJersey: <img alt={'NC_' + record.countryCode} src={getJersey('test', 'NC_' + record.countryCode )} style={{ maxHeight: "18px", marginBottom: 1 }} />
                    }))}
                  rowMetadata={[
                    browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                    { columnName: 'flag', columnDescription: '\u2691' }
                    :
                    { columnName: 'c4fCode', columnDescription: '\u2691', columnType: 'flag' },
                    { columnName: 'country', columnDescription: 'Country' },
                    { columnName: 'NCJersey', columnDescription: 'NC', columnType: 'object' }
                  ]
                  }
                /><br/>
                <h5>Special Jerseys</h5>
                <C4FSimpleTable key={'SpecialJerseyIcons'}
                  initialSortingColumn={'enum'}
                  initialSortingAscending={true}
                  data={specialJerseys
                    .map(record => ({
                      ...record,
                      SpecialJersey: <img alt={record.name} src={getJersey('test', record.name )} height="18px"></img>
                    }))}
                  rowMetadata={[
                    { columnName: 'enum', columnDescription: 'enum' },
                    { columnName: 'name', columnDescription: 'name'},
                    { columnName: 'SpecialJersey', columnDescription: 'SpecialJersey', columnType: 'object'}
                  ]
                  }
                />
                </div>
              </div>
            if (subTab === 'jerseys2')
              return <div className="row d-flex justify-content-center">
                <div className="col" style={{ maxWidth: 800 }}>
                  <h4>Leader Jerseys - Jerseys</h4>
                  <h5>Stage Races</h5>
                  <C4FSimpleTable key={'tourJerseyIcons'}
                  initialSortingColumn={'tourName'}
                  initialSortingAscending={true}
                  data={tourJerseyMapping
                    .map(record => ({
                      ...record,
                      GCLeaderJersey: <img alt="GCLeader" src={config.DIR_JERSEYS + 'leader/' + record.tourName + '_GCLeader.png'} height="60" style={{ marginBottom: 5, marginTop: 5 }} ></img>,
                      PointsJersey: <img alt="Sprint" src={config.DIR_JERSEYS + 'leader/' + record.tourName + '_Sprint.png'} height="60"></img>,
                      MountainJersey: <img alt="Mountain" src={config.DIR_JERSEYS + 'leader/' + record.tourName + '_Mountain.png'} height="60"></img>,
                      YouthJersey: <img alt="Youth" src={config.DIR_JERSEYS + 'leader/' + record.tourName + '_Youth.png'} height="60"></img>
                    }))}
                  rowMetadata={[
                    { columnName: 'tourName', columnDescription: 'Tour' },
                    { columnName: 'GCLeaderJersey', columnDescription: '--- GC ---', columnType: 'object' },
                    { columnName: 'PointsJersey', columnDescription: '- Points -', columnType: 'object' },
                    { columnName: 'MountainJersey', columnDescription: 'Mountain', columnType: 'object' },
                    { columnName: 'YouthJersey', columnDescription: '- Youth -', columnType: 'object' }
                  ]
                  }
                />
                <br/>
                <h5>National Champions</h5>
                <C4FSimpleTable key={'NCJerseyIcons'}
                  initialSortingColumn={'country'}
                  initialSortingAscending={true}
                  data={countries
                    .filter((a) => a.isRiderNationality)
                    .map(record => ({
                      ...record,
                      flag: getUnicodeFlag(record.countryCode),
                      NCJersey: <img alt={'NC_' + record.c4fCode} src={config.DIR_JERSEYS + 'national/trikot_' + record.c4fCode + '.png'} height="60"></img>
                    }))}
                  rowMetadata={[
                    browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                    { columnName: 'flag', columnDescription: '\u2691' }
                    :
                    { columnName: 'c4fCode', columnDescription: '\u2691', columnType: 'flag' },
                    { columnName: 'country', columnDescription: 'Country' },
                    { columnName: 'NCJersey', columnDescription: 'NC', columnType: 'object' }
                  ]
                  }
                />
                <br/>
                <h5>Special Jerseys</h5>
                <C4FSimpleTable key={'SpecialJerseyIcons'}
                  initialSortingColumn={'enum'}
                  initialSortingAscending={true}
                  data={specialJerseys
                    .map(record => ({
                      ...record,
                      SpecialJersey: <img alt={record.name} src={config.DIR_JERSEYS + 'special/' + record.file + '.png'} height="60"></img>
                    }))}
                  rowMetadata={[
                    { columnName: 'enum', columnDescription: 'enum' },
                    { columnName: 'name', columnDescription: 'name'},
                    { columnName: 'SpecialJersey', columnDescription: 'SpecialJersey', columnType: 'object'}
                  ]
                  }
                />
                </div>
              </div>
          })()}
        </>
      if (tab === 'administration')
        return <>
          <Row className="justify-content-center">
            <Col className="col-8">
              <p>
                C4F is run by a number of volunteers, which are listed in the table below, where the member for the following roles are named:
                <ul>
                  <li>Admin: Full technical control over the game, including server and database access</li>
                  <li>Calendar Planner: Full access to the race calendar, including adding and removing races from calendar</li>
                  <li>Nations Committee: see Nationalities tab</li>
                  <li>Fairplay Committee: see Fairplay tab</li>
                  <li>Owner: Official owner of this website (excl. forum), domains and the account with hosting provider IONOS (actually paid by donations from the community)</li>
                  <li>Developer: Full access to the source code, server and database, able to technically provide bug fixes and new functionality</li>
                </ul>
                You want to help the game as well? Please contact any of the role owners!
              </p>
              {userRoles ?
                <C4FSimpleTable key={'userRoles'}
                  initialSortingColumn={'role'}
                  initialSortingAscending={true}
                  hideColumnVisibility={true}
                  data={userRoles}
                  rowMetadata={[
                    { columnName: 'userName', columnDescription: 'User' },
                    { columnName: 'acronym', columnDescription: 'Acronym' },
                    { columnName: 'forumAccount', columnDescription: 'Forum Account' },
                    { columnName: 'role', columnDescription: 'Role' }
                  ]}
                />
                : null}
            </Col>
          </Row>
        </>
      if (tab === 'releaseNotes')
        return <>
          <Row className="justify-content-center">
            <Col>
              <C4FSimpleTable key={'releaseNotes'}
                initialSortingColumn={'role'}
                initialSortingAscending={true}
                hideColumnVisibility={true}
                data={releaseNotes.map(item => ({
                  date: item.date,
                  version: item.version,
                  changes: <ul>
                    {item.changes.map(change => <li>{change}</li>)}
                  </ul>
                }))}
                rowMetadata={[
                  { columnName: 'version', columnDescription: 'Version' },
                  { columnName: 'date', columnDescription: 'Date' },
                  { columnName: 'changes', columnDescription: 'Latest Updates', columnType: 'object', columnAlign: 'left' }
                ]}
              />
            </Col>
          </Row>
        </>
      if (tab === 'financing')
        return <>
          <Row>
            <Col>
              <p>The following table contains an overview of all donations for C4F and how the donations were used.</p>
              <p>Total Donations: {formatCurrency(sum(cashJournal.filter(cj => cj.type === 'Donation').map(cj => cj.value)), 'EUR')}<br></br>
              Total Server Cost: {formatCurrency(-sum(cashJournal.filter(cj => cj.type === 'Server').map(cj => cj.value)), 'EUR')}<br></br>
              <b>Balance: {formatCurrency(sum(cashJournal.map(cj => cj.value)))}</b>
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col>
              {cashJournal ?
                <C4FSimpleTable key={'financing'}
                  initialSortingColumn={'date'}
                  initialSortingAscending={false}
                  hideColumnVisibility={true}
                  data={cashJournal.map(cj => ({ ...cj, valueFormatted: formatCurrency(cj.value, 'EUR') }))}
                  rowMetadata={[
                    { columnName: 'id', columnDescription: 'ID' },
                    { columnName: 'date', columnDescription: 'Date' },
                    { columnName: 'valueFormatted', columnDescription: 'Value' },
                    { columnName: 'type', columnDescription: 'Type' },
                    { columnName: 'description', columnDescription: 'Description' }
                  ]}
                />
              : null }
            </Col>
          </Row>
        </>
      if (tab === 'raceCalculation' && raceEngine)
        return <Container fluid>
          <Row className="d-flex justify-content-center mt-2">
            <Col>
              <ButtonGroup>
                <Button variant={(subTab === 'dataEntry') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('dataEntry')}>Data Entry</Button>
                <Button variant={(subTab === 'calculation') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('calculation')}>Speed and Energy</Button>
                <Button variant={(subTab === 'salaryMarketValue') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setSubTab('salaryMarketValue')}>Salary / Market Value</Button>
              </ButtonGroup>
            </Col>
          </Row>

          {subTab === 'dataEntry' || subTab === 'salaryMarketValue' ? 
          <>
            <Row className="mt-1">
              <Col className="col-6">
                  <h5>Rider #1 <Button variant={'success'} size="sm" onClick={() => setRiderOne(randomizeRider(riderOne))}>{'\u21BB'}</Button></h5>
              </Col>
              <Col className="col-6">
                  <h5>Rider #2 <Button variant={'success'} size="sm" onClick={() => setRiderTwo(randomizeRider(riderTwo))}>{'\u21BB'}</Button></h5>
              </Col>
            </Row>
            <Row>
              <Col className="col-3">
                <C4FSimpleTextField className="mt-1"
                  key={'ClimbingRiderOne'}
                  name={'climbingRiderOne'}
                  displayName={'climbing'}
                  value={riderOne.climbing}
                  updateMethod={updateRider} />
                <C4FSimpleTextField className="mt-1"
                  key={'FlatRiderOne'}
                  name={'flatRiderOne'}
                  displayName={'flat'}
                  value={riderOne.flat}
                  updateMethod={updateRider} />
                <C4FSimpleTextField className="mt-1"
                  key={'DownhillRiderOne'}
                  name={'downhillRiderOne'}
                  displayName={'downhill'}
                  value={riderOne.downhill}
                  updateMethod={updateRider} />
                <C4FSimpleTextField className="mt-1"
                  key={'TimeTrialRiderOne'}
                  name={'timeTrialRiderOne'}
                  displayName={'timeTrial'}
                  value={riderOne.timeTrial}
                  updateMethod={updateRider} />
                <C4FSimpleTextField className="mt-1"
                  key={'SprintRiderOne'}
                  name={'sprintRiderOne'}
                  displayName={'sprint'}
                  value={riderOne.sprint}
                  updateMethod={updateRider} />
                <C4FSimpleTextField className="mt-1"
                  key={'RegenerationRiderOne'}
                  name={'regenerationRiderOne'}
                  displayName={'regeneration'}
                  value={riderOne.regeneration}
                  updateMethod={updateRider} />
              </Col>
              <Col className="col-3">
                <C4FSimpleTextField className="mt-1"
                  key={'CobblesRiderOne'}
                  name={'cobblesRiderOne'}
                  displayName={'cobbles'}
                  value={riderOne.cobbles}
                  updateMethod={updateRider} />
                <C4FSimpleTextField className="mt-1"
                  key={'EnergyRiderOne'}
                  name={'energyRiderOne'}
                  displayName={'energy'}
                  value={riderOne.energy}
                  updateMethod={updateRider} />
                <C4FReferenceDataSelection className="mt-1"
                  key={'intensityRiderOne'}
                  name={'intensityRiderOne'}                                    
                  displayName={'intensity'}
                  value={riderOne.intensity}
                  referenceDataValues={['None', 'Green', 'Blue', 'Red']}
                  updateMethod={updateRider} />
              </Col>
              <Col className="col-3">
                <C4FSimpleTextField className="mt-1"
                  key={'ClimbingRiderTwo'}
                  name={'climbingRiderTwo'}
                  displayName={'climbing'}
                  value={riderTwo.climbing}
                  updateMethod={updateRider} />
                <C4FSimpleTextField className="mt-1"
                  key={'FlatRiderTwo'}
                  name={'flatRiderTwo'}
                  displayName={'flat'}
                  value={riderTwo.flat}
                  updateMethod={updateRider} />
                <C4FSimpleTextField className="mt-1"
                  key={'DownhillRiderTwo'}
                  name={'downhillRiderTwo'}
                  displayName={'downhill'}
                  value={riderTwo.downhill}
                  updateMethod={updateRider} />
                <C4FSimpleTextField className="mt-1"
                  key={'TimeTrialRiderTwo'}
                  name={'timeTrialRiderTwo'}
                  displayName={'timeTrial'}
                  value={riderTwo.timeTrial}
                  updateMethod={updateRider} />
                <C4FSimpleTextField className="mt-1"
                  key={'SprintRiderTwo'}
                  name={'sprintRiderTwo'}
                  displayName={'sprint'}
                  value={riderTwo.sprint}
                  updateMethod={updateRider} />
                <C4FSimpleTextField className="mt-1"
                  key={'RegenerationRiderTwo'}
                  name={'regenerationRiderTwo'}
                  displayName={'regeneration'}
                  value={riderTwo.regeneration}
                  updateMethod={updateRider} />
              </Col>
              <Col className="col-3">
                <C4FSimpleTextField className="mt-1"
                  key={'CobblesRiderTwo'}
                  name={'cobblesRiderTwo'}
                  displayName={'cobbles'}
                  value={riderTwo.cobbles}
                  updateMethod={updateRider} />
                <C4FSimpleTextField className="mt-1"
                  key={'EnergyRiderTwo'}
                  name={'energyRiderTwo'}
                  displayName={'energy'}
                  value={riderTwo.energy}
                  updateMethod={updateRider} />
                <C4FReferenceDataSelection className="mt-1"
                  key={'intensityRiderTwo'}
                  name={'intensityRiderTwo'}                                    
                  displayName={'intensity'}
                  value={riderTwo.intensity}
                  referenceDataValues={['None', 'Green', 'Blue', 'Red']}
                  updateMethod={updateRider} />
              </Col>
            </Row>
            {subTab === 'dataEntry' ? 
              <>
                <Row className="mt-1">
                  <Col>
                      <h5>Weather <Button variant={'success'} size="sm" onClick={() => randomizeWeather()}>{'\u21BB'}</Button></h5>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col className="col-3">
                    <C4FReferenceDataSelection
                      key={'clouds'}
                      name={'clouds'}
                      displayName={'clouds'}
                      value={weather.clouds}
                      referenceDataValues={weatherCloudTypes}
                      updateMethod={updateWeather} />
                  </Col>
                  <Col className="col-3">
                    <C4FSimpleTextField
                      key={'temperature'}
                      name={'temperature'}
                      displayName={'temperature'}
                      value={weather.temperature}
                      updateMethod={updateWeather} />              
                  </Col>
                  <Col className="col-3">
                    <C4FSimpleTextField
                      key={'windforce'}
                      name={'windforce'}
                      displayName={'windforce'}
                      value={weather.windforce}
                      updateMethod={updateWeather} />
                  </Col>
                  <Col className="col-3">
                    <C4FReferenceDataSelection
                      key={'precipitation'}
                      name={'precipitation'}
                      displayName={'precipitation'}
                      value={weather.precipitation}
                      referenceDataValues={weatherPrecipitationTypes}
                      updateMethod={updateWeather} />
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col>
                    <h5>Sector <Button variant={'success'} size="sm" onClick={() => randomizeSector()}>{'\u21BB'}</Button></h5>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col className="col-3">
                    <C4FReferenceDataSelection
                      key={'direction'}
                      name={'direction'}
                      displayName={'direction'}
                      value={sector.direction}
                      referenceDataValues={sectorDirectionTypes}
                      updateMethod={updateSector} />              
                  </Col>
                  <Col className="col-3">
                    <C4FReferenceDataSelection
                      key={'width'}
                      name={'width'}
                      displayName={'width'}
                      value={sector.width}
                      referenceDataValues={sectorWidthTypes}
                      updateMethod={updateSector} />              
                  </Col>
                  <Col className="col-3">
                    <C4FReferenceDataSelection
                      key={'coverage'}
                      name={'coverage'}
                      displayName={'coverage'}
                      value={sector.coverage}
                      referenceDataValues={sectorCoverageTypes}
                      updateMethod={updateSector} />              
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col>
                    <C4FSimpleTable key={'calculationPerSector'}
                      initialSortingColumn={'incline'}
                      initialSortingAscending={true}                  
                      data={raceEngine.sectorTypes.map(sectorType => {
                        let selectedSector = { ...sectorType, ...sector };
                        let calculatedSkillRiderOne = calculateSkill(raceEngine, selectedSector, riderOne);
                        let calculatedSpeedRiderOne = calculateSpeed(raceEngine, selectedSector, riderOne, weather);
                        let calculatedSkillRiderTwo = calculateSkill(raceEngine, selectedSector, riderTwo);
                        let calculatedSpeedRiderTwo = calculateSpeed(raceEngine, selectedSector, riderTwo, weather);
                        return {
                          ...selectedSector,
                          calculatedSkillRiderOne: calculatedSkillRiderOne,
                          calculatedSpeedRiderOne: calculatedSpeedRiderOne,
                          durationRiderOne: 1000 / (calculatedSpeedRiderOne / 3.6),
                          calculatedSkillRiderTwo: calculatedSkillRiderTwo,
                          calculatedSpeedRiderTwo: calculatedSpeedRiderTwo,
                          durationRiderTwo: 1000 / (calculatedSpeedRiderTwo / 3.6),
                          gap: 1000 / (calculatedSpeedRiderTwo / 3.6) - 1000 / (calculatedSpeedRiderOne / 3.6)
                        }})}
                      rowMetadata={[
                        { columnName: 'incline', columnDescription: 'Incline', cellClickEvent: handleSetSelectedSectorType },
                        { columnName: 'surface', columnDescription: 'Surface', cellClickEvent: handleSetSelectedSectorType },
                        { columnName: 'baseSpeed', columnDescription: 'Base Speed' },
                        { columnName: 'calculatedSkillRiderOne', columnDescription: 'Skill #1' },
                        { columnName: 'calculatedSkillRiderTwo', columnDescription: 'Skill #2' },
                        { columnName: 'calculatedSpeedRiderOne', columnDescription: 'Speed #1' },
                        { columnName: 'calculatedSpeedRiderTwo', columnDescription: 'Speed #2' },
                        { columnName: 'durationRiderOne', columnDescription: 'Dur. #1' },
                        { columnName: 'durationRiderTwo', columnDescription: 'Dur. #2' },
                        { columnName: 'gap', columnDescription: 'Gap' },
                      ]}
                    />

                  </Col>
                </Row>
              </>
            : null }
          </>
          : null}
          {subTab === 'calculation' && selectedSectorType ? 
            <>
              <Row className="mt-2">
                <Col className="col-4">
                  <h5>Rider <Button variant={'success'} size="sm" onClick={() => setRiderOne(randomizeRider(riderOne))}>{'\u21BB'}</Button></h5>
                  {printJSONObject(riderOne)}
                </Col>
                <Col className="col-4">
                  <h5>Sector <Button variant={'success'} size="sm" onClick={() => randomizeSector()}>{'\u21BB'}</Button></h5>
                  {printJSONObject(selectedSectorType)}
                </Col>
                <Col className="col-4">
                  <h5>Weather <Button variant={'success'} size="sm" onClick={() => randomizeWeather()}>{'\u21BB'}</Button></h5>
                  {printJSONObject(weather)}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col>
                  <Table size="sm" bordered>
                    <thead>
                      <tr>
                        <th>Step</th>
                        <th>Description</th>
                        <th>Formula</th>
                        <th>Result</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* sector speed */}
                      <tr>
                        <th rowSpan={4}>sectorSpeed</th>
                        <td>sectorBaseSpeed (defined by surface, incline)</td>
                        <td></td>
                        <td>{selectedSectorType.baseSpeed}</td>
                      </tr>
                      <tr>
                        <td>sectorMaxSpeed (direction, width)</td>
                        <td>winding roads reduce high speeds, don't affect low ones</td>
                        <td>{calculateRoadFactor(selectedSectorType)}</td>
                      </tr>
                      <tr>
                        <td>rainFactor</td>
                        <td>depending on sector type (defined by surface, incline)?</td>
                        <td>{calculatePrecipitationFactor(selectedSectorType, weather)}</td>
                      </tr>
                      <tr>
                        <th>Result</th>
                        <td></td>
                        <th>{roundDigits(calculateSectorSpeed(selectedSectorType, weather), 2)}</th>
                      </tr>
                      {/* calculated skill start */}
                      <tr>
                        <th rowSpan={4}>calculatedSkill</th>
                        <td>sectorSkill (defined by surface, incline)</td>
                        <td>{getCalculatedSkillFormula()}</td>
                        <td>{roundDigits(calculateSkill(raceEngine, selectedSectorType, { ...riderOne, energy: 1000 }, true), 2)}</td>
                      </tr>
                      <tr>
                        <td>form</td>
                        <td>100: +2, 85: -2</td>
                        <td>{formBonus(riderOne.form)}</td>
                      </tr>
                      <tr>
                        <td>energyFactor</td>
                        <td>* ((10 * energy + {raceEngine.modifiers.energy.baseFloor}) / {raceEngine.modifiers.energy.baseFloor + raceEngine.modifiers.energy.base}) ^ {raceEngine.modifiers.energy.power}</td>
                        <td>* {roundDigits(calculateEnergyFactor(raceEngine, riderOne), 3)}</td>
                      </tr>
                      <tr>
                        <th>Result</th>
                        <td></td>
                        <th>{roundDigits(calculateSkill(raceEngine, selectedSectorType, riderOne), 2)}</th>
                      </tr>
                      {/* wind factor start */}
                      <tr>
                        <th rowSpan={4}>windFactor</th>
                        <td>relativeWindDirection</td>
                        <td>sector bearing - wind direction</td>
                        <td>{selectedSectorType.bearing - weather.windDirection}</td>
                      </tr>
                      <tr>
                        <td>relativeWindforce</td>
                        <td>cos(relativeWindDirection) * windforce</td>
                        <td>{roundDigits(calculateRelativeWindforce(selectedSectorType, weather), 3)}</td>
                      </tr>
                      <tr>
                        <td>tbd - wind factor per sector base speed?</td>
                        <td>tbd</td>
                        <td>tbd</td>
                      </tr>
                      <tr>
                        <th>Result</th>
                        <td>1 - relativeWindforce * {raceEngine.modifiers.wind.factor}</td>
                        <th>{roundDigits(calculateWindFactor(raceEngine, selectedSectorType, weather), 3)}</th>
                      </tr>
                      {/* effective skill start */}
                      <tr>
                        <th rowSpan={4}>effectiveSkill</th>
                        <td>calculatedSkill</td>
                        <td>from previous step</td>
                        <td>{roundDigits(calculateSkill(raceEngine, selectedSectorType, riderOne), 2)}</td>
                      </tr>
                      <tr>
                        <td>windFactor</td>
                        <td>from previous step</td>
                        <td>{roundDigits(calculateWindFactor(raceEngine, selectedSectorType, weather), 3)}</td>
                      </tr>
                      <tr>
                        <td>randomFactor<br></br></td>
                        <td>
                          Gaussian normal distribution (average 1, std deviation 0.01)<br></br>
                          tbd - smaller on straight roads, higher on difficult terrain
                        </td>
                        <td>{riderOne.randomFactor} <Button variant={'success'} size="sm" onClick={() => handleSetRandomSkillFactor()}>{'\u21BB'}</Button></td>
                      </tr>
                      <tr>
                        <th>Result</th>
                        <td>calculatedSkill * windFactor * randomFactor</td>
                        <th>{roundDigits(calculateEffectiveSkill(raceEngine, selectedSectorType, riderOne, weather), 2)}</th>
                      </tr>
                      {/* max speed per rider start */}
                      <tr>
                        <th rowSpan={3}>riderMaxSpeed</th>
                        <td>sectorSpeed</td>
                        <td>from previous step</td>
                        <td>{roundDigits(calculateRoadFactor(selectedSectorType) * calculatePrecipitationFactor(selectedSectorType, weather), 2)}</td>
                      </tr>
                      <tr>
                        <td>slipstreamEffectiveSkill (tbd)</td>
                        <td>from previous step (just effectiveSkill for now)</td>
                        <td>{roundDigits(calculateEffectiveSkill(raceEngine, selectedSectorType, riderOne, weather), 2)}</td>
                      </tr>
                      <tr>
                        <th>Result</th>
                        <td>sectorSpeed * (effectiveSkill / {raceEngine.baseSkill}) ^ {selectedSectorType.skillImpact.power}</td>
                        <th>{roundDigits(calculateSpeed(raceEngine, selectedSectorType, riderOne, weather), 2)}</th>
                      </tr>
                    </tbody>
                  </Table>
                  {/* <Table size="sm" bordered>
                    <thead>
                      <tr>
                        <th>Step</th>
                        <th>Description</th>
                        <th>Formula</th>
                        <th>Result</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Actual tempo success</td>
                        <td>
                          <ul>
                            <li>effective skill</li>                    
                            <li>tempo settings of all riders in the group (and merging groups)</li>
                            <li>attacks / follows</li>                    
                          </ul>
                        </td>
                        <td>xyz</td>
                        <td>xyz</td>
                      </tr>
                      <tr>
                        <td>Effective Skill with slipstream</td>
                        <td>
                          <ul>
                            <li>effective skill</li>
                            <li>wind direction and force</li>
                            <li>slipstream factor (based on position, tempo strategy, intensity and success)</li>                    
                          </ul>
                        </td>
                        <td>xyz</td>
                      </tr>
                      <tr>
                        <td>Max Speed per rider</td>
                        <td>
                          <ul>
                            <li>base speed of sector (defined by surface, incline)</li>
                            <li>direction (winding roads reduce high speeds, don't affect low ones)</li>
                            <li>rain depending on sector type (defined by surface, incline)?</li>
                            <li>effective skill with slipstream (base 75)</li>                                        
                            <li>optional: temperature? very high temperature affects low speeds? very low temperatures affect high speed?</li>
                          </ul>
                        </td>
                        <td>xyz</td>
                      </tr>
                      <tr>
                        <td>Group Speed</td>
                        <td>
                          <ul>
                            <li>tempo settings of attackers, successful tempo makers</li>                    
                            <li>max speed per rider</li>                    
                          </ul>
                        </td>
                        <td>xyz</td>
                      </tr>
                      <tr>
                        <td>Actual Speed per rider</td>
                        <td>
                          <ul>
                            <li>group speed when staying, own speed when dropped</li>
                            <li>max speed per rider</li>
                            <li>fighting (fight, keep up, relax)</li>                    
                          </ul>
                        </td>
                        <td>xyz</td>
                      </tr>
                      <tr>
                        <td>Energy</td>
                        <td>
                          <ul>                    
                            <li>base energy consumption for sector type?</li>
                            <li>max speed for effective skill and position</li>
                            <li>actual speed for effective skill and position</li>
                            <li>malus for tempo, attacks and following</li>
                            <li>temperature / cloudcover</li>
                            <li>help from teammate</li>
                            <li>slipstream / draft</li>
                          </ul>
                        </td>
                        <td>xyz</td>
                      </tr>
                      <tr>
                        <td>Duration</td>
                        <td>
                          <ul>                    
                            <li>actual speed</li>
                            <li>sector length</li>
                          </ul>
                        </td>
                        <td>xyz</td>
                      </tr>
                    </tbody>
                  </Table> */}
                </Col>
              </Row>
            </>
          : null }
          {subTab === 'salaryMarketValue' && selectedSectorType ? 
            <>
              <Row>
                <Col className="col-6">
                  <h5>Salary</h5>
                  Rider One: {calculateRiderSalary(riderOne)}<br></br>
                  Rider Two: {calculateRiderSalary(riderTwo)}
                </Col>
                <Col className="col-6">
                  <h5>Market Value</h5>
                  Rider One: {calculateRiderValue(riderOne)}<br></br>
                  Rider Two: {calculateRiderValue(riderTwo)}
                </Col>                
              </Row>
            </>
          : null }
        </Container>
    })()}
    <Row className="d-flex p-0 m-1 justify-content-center">
      <Col style={{ textAlign: "center" }}>
        <br />
        <br />
        <br />
        <br />
        <br />
        <p>Visit the <a href={config.FORUM_BASE_URL} target="_blank" rel="noreferrer">Forum</a> to find more information, ask questions or <a href={config.FORUM_BASE_URL + 'viewtopic.php?f=66&t=9173'} target="_blank" rel="noreferrer">improve the manual</a>.</p>
        <br />
        <br />
        <br />
      </Col>
    </Row>
  </Container>;
}

export default Manual;
